import jq from 'jquery';
import { cookieBase, cdnUrls } from 'server-data/flconfigs';
import { oneLine, oneLineTrim } from 'common-tags';
import 'css/flux/modules/Modal.less';
import 'bootstrap';
import _ from 'underscore';
import { contestId, messagesData, showMessageBoard, allowViewMoreEntries, topEntriesCount } from 'server-data/contest-view-logged-out';

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function assignInDefaults(objValue, srcValue, key, object) {
  if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
    return srcValue;
  }
  return objValue;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto$2.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Reflect = root.Reflect;

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var enumerate = Reflect ? Reflect.enumerate : undefined,
    propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * The base implementation of `_.keysIn` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  object = object == null ? object : Object(object);

  var result = [];
  for (var key in object) {
    result.push(key);
  }
  return result;
}

// Fallback for IE < 9 with es6-shim.
if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
  baseKeysIn = function baseKeysIn(object) {
    return iteratorToArray(enumerate(object));
  };
}

var baseKeysIn$1 = baseKeysIn;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$4.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty$2.call(value, 'callee') && (!propertyIsEnumerable$1.call(value, 'callee') || objectToString$1.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$5.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString$2.call(value) == stringTag;
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) && (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$6;

  return value === proto;
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  var index = -1,
      isProto = isPrototype(object),
      props = baseKeysIn$1(object),
      propsLength = props.length,
      indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  while (++index < propsLength) {
    var key = props[index];
    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) && !(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/** `Object#toString` result references. */
var errorTag = '[object Error]';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$3 = objectProto$8.toString;

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object,
 *  else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  return objectToString$3.call(value) == errorTag || typeof value.message == 'string' && typeof value.name == 'string';
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function (func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/**
 * Creates a function that invokes `func` with its first argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf;

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
var getPrototype = overArg(nativeGetPrototype, Object);

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return object != null && (hasOwnProperty$4.call(object, key) || typeof object == 'object' && key in object && getPrototype(object) === null);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object.keys;

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
var baseKeys = overArg(nativeKeys, Object);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) && !(skipIndexes && (key == 'length' || isIndex(key, length))) && !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Built-in value references. */
var Symbol = root.Symbol;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto$10 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$4 = objectProto$10.toString;

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString$4.call(value) == symbolTag;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape$1(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB). Change the following template settings to use
 * alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape$1 }
  }
};

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, assignInDefaults);

  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';

  var result = attempt(function () {
    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto$11 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$5 = objectProto$11.toString;

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && objectToString$5.call(value) == numberTag;
}

function setCookie(cName, value, expiredays) {
  var expiremins = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie = cName + '=' + value + ('' + (expiredays == null ? '' : ';expires=' + exdate.toUTCString())) + '; path=/; secure';
}

function getCookie(cName) {
  var cookies = document.cookie;
  if (cookies.length > 0) {
    var cStart = cookies.indexOf(cName + '=');
    if (cStart != -1) {
      cStart = cStart + cName.length + 1;
      var cEnd = cookies.indexOf(';', cStart);
      if (cEnd == -1) cEnd = cookies.length;
      return cookies.substring(cStart, cEnd);
    }
  }
  return '';
}

function getUserIdfromCookie() {
  return getCookie(cookieBase + '_USER_ID');
}

// DEPRECATED. Just use cookieBase from 'server-data/flconfigs'
// const getCookieBase;

function getAuthHeader() {
  var authHashV2 = getCookie(cookieBase + '_AUTH_HASH_V2');
  var userId = getUserIdfromCookie();
  return { 'Freelancer-Auth-V2': userId + ';' + authHashV2 };
}

function randomString(length, chars) {
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return result;
}

function getCSRFToken() {
  var token = getCookie('XSRF-TOKEN');
  if (!token) {
    token = randomString(64, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    setCookie('XSRF-TOKEN', token, 7);
  }
  return token;
}

var TRANSLATE_MODE_COOKIE = cookieBase + '_TRANSLATE_MODE';

var isTranslateModeEnabled = function isTranslateModeEnabled() {
  return getCookie(TRANSLATE_MODE_COOKIE) === '1';
};

var getTokenizedMessage = function getTokenizedMessage(id, message) {
  return isTranslateModeEnabled() ? '~=[' + id + '|^|' + message + ']=~' : message;
};

var translate = function translate(first) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  switch (true) {
    case isString(first):
      {
        var text = first;
        var vars = rest[0];
        if (typeof vars === 'undefined' || !vars) {
          return text;
        }
        var result = template(text, {
          evaluate: /<\[([\s\S]+?)\]>/g,
          interpolate: /<\[=([\s\S]+?)\]>/g,
          escape: /<\[-([\s\S]+?)\]>/g
        })(vars);
        result = template(result)(vars);
        return result;
      }
    case isArray(first):
      {
        return oneLine([translate.raw.apply(translate, [first].concat(rest))]);
      }
    case isNumber(first):
      {
        var _ret = function () {
          var sourceTextId = first;
          return {
            v: function v() {
              return getTokenizedMessage(sourceTextId, translate.apply(undefined, arguments));
            }
          };
        }();

        if (typeof _ret === "object") return _ret.v;
      }
    default:
      {
        throw new TypeError('Invalid argument types');
      }
  }
};

translate.raw = function rawT(literals) {
  for (var _len2 = arguments.length, placeholders = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    placeholders[_key2 - 1] = arguments[_key2];
  }

  return literals.raw.reduce(function (str, current, index) {
    var temp = str + current;
    if (index < placeholders.length) {
      temp += placeholders[index].toString();
    }
    return temp;
  }, '');
};

/**
 * Loads the contents of an SVG file and injects it to where it's being called.
 * In its originality this function is only used with the Underscore templating
 * engine, so it only works if the template is being rendered right after
 * compilation.
 * @param  {String} icon The icon name. Consult with FEDs or the
 * [Pattern Library](https://patternlibrary.freelancer.com)
 *                       for the naming convention of the icon you're using.
 * @return {String}      A temporary placeholder element to be replaced later
 * after the XHR fetches the SVG.
 */

function generateUniqueIdentifier() {
  var identifier = 'uiIcon-' + Math.floor(Math.random() * 1024);
  // Does the passwordless form with that identifier exist? Reroll the
  // dice again to get a new unique one.
  if (document.getElementById(identifier)) {
    return generateUniqueIdentifier();
  }

  return identifier;
}

function uiIcon(icon) {
  // Make a placeholder element to be replaced with the SVG later.
  var identifier = generateUniqueIdentifier();
  var placeholderHTML = '<span id="' + identifier + '"></span>';

  // Fetch the contents of the SVG file we're going to replace it with.
  var placeholderNode = void 0;
  // DO NOT use the SystemJS API without talking to @laurent first! Things
  // might go really bad if you do.
  fetch(SystemJS.normalizeSync('icons/' + icon + '.svg')).then(function (response) {
    if (response.ok) {
      return response.text();
    }

    // Remove the placeholder element if the icon is not found or some server
    // problems happened.
    placeholderNode = document.getElementById('' + identifier);
    if (placeholderNode.parentNode) {
      placeholderNode.parentNode.removeChild(placeholderNode);
    }
    throw new Error();
  }).then(function (html) {
    var replace = function replace() {
      placeholderNode = document.getElementById('' + identifier);
      // Sometimes the templates are rendered but never inserted in the DOM
      // ¯\_(ツ)_/¯
      if (placeholderNode) {
        placeholderNode.outerHTML = html;
      }
    };

    // Replace the placeholder element at the next animation frame if possible
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(replace);
    } else {
      replace();
    }
    // 404 or something else happened. Don't worry about it.
  }).catch(function () {
    return undefined;
  });

  // While that call's happening return the placeholder element to be injected
  // to the template first.
  return placeholderHTML;
}

var _classCallCheck = (function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

/*
  QTS Binding Library
  This includes functions for binding qts pushing to events, as follows:
  init()
  - initializes default values for all qts events
    this may set two separate default values for the navbar and for the page
    push()
  - used for js process events, not directly w/ user interaction
    bind()
  - bind to an element click event.
    if contains a link, it shall prevent & setTimeout to allow qts pixel
    request, before redirecting.
*/

// general container for all qtsbinds data;
var qtsv = {
  timeout: false,
  defaults: {},
  page: {},
  nav: {}
};

qtsv.defaults = {
  pageContainer: '.gaf-container:first',
  navContainer: '.header-and-nav'
};

var setDefault = function setDefault(params, isNav) {
  if (typeof isNav === 'boolean' && isNav) {
    if (params) {
      Object.keys(params).forEach(function (pkey) {
        qtsv.nav[pkey] = params[pkey];
      });
    }
  } else if (params) {
    Object.keys(params).forEach(function (pkey) {
      qtsv.page[pkey] = params[pkey];
    });
  }
  qtsv.timeout = false;
};

var push = function push(params, url, isNav) {
  var qvars = qtsv;
  if (!qvars.timeout) {
    (function () {
      var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

      if (typeof params === 'object') {
        if (params) {
          Object.keys(params).forEach(function (pkey) {
            if (pkey != 'eventName') {
              paramSet[pkey] = params[pkey];
            }
          });
        }
      } else if (typeof params === 'string') {
        paramSet.label = params;
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _t.push(['user_action', paramSet]);
      }

      setTimeout(function () {
        if (typeof url === 'string') {
          window.location = url;
        }
      }, 1000);

      setTimeout(function () {
        qvars.timeout = false;
      }, 100);

      qvars.timeout = true;
    })();
  }
};

var createBind = function createBind(ifselector, params, isNav) {
  var qvars = qtsv;

  params = params || {};

  var containerEl = qvars.defaults.pageContainer;
  var selector = '[data-qts]';

  if (typeof ifselector === 'string') {
    selector = ifselector;
  } else if (typeof ifselector === 'object') {
    selector = ifselector.id;
    // attach conditional values to element so it won't be lost after binding
    jq(selector).attr('data-qtcon', ifselector.con);
    jq(selector).attr('data-qt0', ifselector.falsy);
    jq(selector).attr('data-qt1', ifselector.truthy);
  }

  if (typeof isNav === 'string') {
    containerEl = isNav;
  } else if (typeof isNav === 'boolean' && isNav == true) {
    containerEl = qvars.defaults.navContainer;
  }

  jq(containerEl).on('click', selector, function (e) {
    e.preventDefault();
    // if navbar is a link, assign triggerable flag so it can be triggered after
    // qts is pushed.
    var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

    var thisEl = jq(e.currentTarget);
    var triggerable = false;
    if (typeof thisEl.attr('href') !== 'undefined') {
      triggerable = true;
    }

    if (!qtsv.timeout) {
      if (params) {
        Object.keys(params).forEach(function (pkey) {
          if (pkey != 'eventName') {
            paramSet[pkey] = params[pkey];
          }
        });
      }

      var label = thisEl.data('qts');

      if (typeof label !== 'undefined') {
        paramSet.label = label;
      }

      // for conditional selectors
      var hasCondition = typeof thisEl.data('qtcon') !== 'undefined';

      if (hasCondition) {
        // toggle text value (qt1 or qt0) depending on condition (qtcon)
        if (thisEl.data('qtcon') == false) {
          paramSet.label = thisEl.data('qt1');
          thisEl.data('qtcon', true);
        } else {
          paramSet.label = thisEl.data('qt0');
          thisEl.data('qtcon', false);
        }
      }

      if (typeof paramSet.action === 'undefined') {
        paramSet.action = 'click';
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _lt.push(['user_action', paramSet]);
      }

      // sets a timeout fxn & timer to measure if qts push taking too long.
      qtsv.timer = setTimeout(function () {
        qtsv.timeout = false;
        if (triggerable) {
          window.location = thisEl.attr('href');
        }
      }, 1000);

      qtsv.timeout = true;
      qtsv.timerRun = 0;
    }
  });
};

qtsv.push = push;

var qtsp = {
  init: setDefault,
  bind: createBind,
  push: push
};

function processEvent(event) {
  var eventName = event.event;
  if (eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }
  if (eventName == 'NonHireMe Posted') {
    _ttref.push(['_trackEvent', 'PostProject', 'Posted']);
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_PostProjectForm']);
  } else if (eventName == 'Buy Exam') {
    _ttref.push(['_trackEvent', 'Exams', 'ConfirmBuy', event.examName]);
  } else if (eventName == 'Bid on Project') {
    _ttref.push(['_trackEvent', 'Project', 'Bid', '', 0, true, true]);
    qtsp.push({
      label: 'PlaceBid',
      amount: event.amount,
      currency: event.currency
    });
  } else if (eventName == 'Contest Reposted') {
    _ttref.push(['_setEntrypoint', 'Contest_RepostSuccessContest']);
  } else if (eventName == 'Entries Submitted') {
    // track the submitted entries from dropdown notification
    if (event.xp_contest) {
      _ttref.push(['_trackEvent', 'Contest', 'SubmitEntry', 'XP Contest']);
      _ttref.push(['_clearEntrypoint', 'Contest']);
    }
    if (event.realtime_contest) {
      _ttref.push(['_trackEvent', 'Contest', 'SubmitEntry', 'Realtime Notification Contest']);
      _ttref.push(['_clearEntrypoint', 'Contest']);
    }
  } else if (eventName == 'Suggestion Click') {
    _t.push(['project_suggestion_redirect', {
      bidder_id: event.bidder_id,
      src_project_id: event.src_project_id,
      dst_project_id: event.dst_project_id,
      time: new Date()
    }]);
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_Suggestion']);
    _ttref.push(['_trackEvent', 'Project', 'Suggestion', 'clicked', 0, false, true]);
  } else if (eventName == 'Service View') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'ViewPage',
      action: 'view'
    }]);
  } else if (eventName == 'Service Order Modal Cancel') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderModal',
      label: 'OrderModalCancel',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Button Click') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderButton',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Confirm Modal') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderModal',
      label: 'OrderModal',
      action: 'view'
    }]);
  } else if (eventName == 'Service Order Button Click Logged Out') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderButtonLoggedOut',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Payment Verified') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderModalOkPaymentVerified',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Modal Purchase') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderModalOkPurchase',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Modal Ok') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderModal',
      label: 'OrderModalOk',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Login Modal Login') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderLoginModal',
      label: 'Login',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Login Modal FB Login') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderLoginModal',
      label: 'FBLogin',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Login Modal Sign Up') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderLoginModal',
      label: 'SignUp',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Deposit') {
    _t.push(['user_action', {
      section: 'ServiceDepositPage',
      label: 'OrderDepositPage',
      action: 'view'
    }]);
  } else if (eventName == 'Service Order Deposit Success') {
    _t.push(['user_action', {
      section: 'ServiceProjectPage',
      label: 'ServicePurchasedFromDeposit',
      action: 'view'
    }]);
  } else if (eventName == 'Dashboard MyProjects') {
    _t.push(['user_action', {
      section: 'Dashboard',
      subsection: 'Topnav',
      label: 'MyProjects'
    }]);
  } else if (eventName == 'Service Order Deposit Other Methods') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderDepositModal',
      label: 'OrderDepositOtherMethods',
      action: 'view'
    }]);
  } else if (eventName == 'Showcase Upsell PVP') {
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_ShowcaseUpsell']);

    _t.push(['user_action', {
      section: 'ProjectShowcaseUpsell',
      subsection: 'RepostButton',
      label: event.source,
      action: 'click'
    }]);
  } else if (eventName == 'Front Page Log In') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'FrontPageUpperRight',
      action: 'click'
    }]);
  } else if (eventName == 'Post Project Log In') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'PostProjectPage',
      action: 'click'
    }]);
  } else if (eventName == 'Post Contest Log In') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'PostContestPage',
      action: 'click'
    }]);
  } else if (eventName == 'Top Right Corner') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'TopRightCorner',
      action: 'click'
    }]);
  } else if (eventName == 'Hire Me Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'HireMePage',
      action: 'click'
    }]);
  } else if (eventName == 'User Login Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'UserLogInPage',
      action: 'click'
    }]);
  } else if (eventName == 'Repost Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'RepostPage',
      action: 'click'
    }]);
  } else if (eventName == 'Sign Up Modal') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'SignUpModal',
      action: 'click'
    }]);
  } else if (eventName == 'Find Freelancers Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'FindFreelancersPage',
      action: 'click'
    }]);
  } else if (eventName == 'Directory Page Search') {
    _t.push(['search', {
      section: 'Directory',
      source: event.source,
      keyword: event.keyword,
      filters: event.filters,
      items_displayed: event.items_displayed,
      items_count: event.items_count,
      items_page: event.items_page
    }]);
  } else if (eventName == 'Navigation Bar Search') {
    _t.push(['search', {
      section: 'MainNav',
      keyword: event.keyword
    }]);
  } else if (eventName == 'Jobs Page Search') {
    _t.push(['search', {
      section: 'JobTable',
      source: event.source,
      keyword: event.keyword,
      filters: event.filters,
      items_displayed: event.items_displayed,
      items_count: event.items_count,
      items_page: event.items_page,
      sort: event.sort
    }]);
  } else if (eventName == 'Work Search') {
    _t.push(['search', {
      section: 'WorkTable',
      source: event.source,
      keyword: event.keyword,
      filters: event.filters,
      items_displayed: event.items_displayed,
      items_count: event.items_count,
      items_page: event.items_page,
      sort: event.sort
    }]);
  } else if (eventName == 'Project View Page - Upsell Banner') {
    _t.push(['user_action', {
      section: 'ProjectViewPage',
      subsection: event.eventOption.subsection,
      label: event.eventOption.label,
      action: event.eventOption.action
    }]);
  } else if (eventName === 'Project View Page - Bid on this project') {
    _t.push(['user_action', {
      section: 'Project',
      sub_section: 'BidTheProject',
      label: event.label
    }]);
  } else {
    _t.push(event);
  }
}

function LocalTracking() {
  this._events = [];
}

LocalTracking.prototype._save = function () {
  try {
    localStorage.setItem('LocalTracking', JSON.stringify(this._events));
  } catch (e) {
    return false;
  }
};

LocalTracking.prototype._restore = function () {
  try {
    var events = JSON.parse(localStorage.getItem('LocalTracking'));
    for (var _i = 0, _len = events.length; _i < _len; _i++) {
      this.push(events[_i]);
    }
  } catch (e) {
    return false;
  }
};

LocalTracking.prototype._process = function () {
  var events = this._events;
  this._events = [];
  for (var _i = 0, _len = events.length; _i < _len; _i++) {
    processEvent(events[_i]);
  }
  try {
    localStorage.removeItem('LocalTracking');
  } catch (e) {
    return false;
  }
  return true;
};

LocalTracking.prototype.push = function (event, options) {
  var delay = 5000;

  if (typeof options === 'object') {
    delay = options.delay ? options.delay : delay;
  }

  this._events.push(event);
  this._save();
  var self = this;
  setTimeout(function () {
    self._process();
  }, delay);
  return 1;
};

LocalTracking.prototype.init = function (_t) {
  var event = void 0;
  var _i = void 0;
  var _len = void 0;
  this._restore();
  if (_t == null) {
    _t = [];
  }
  for (_i = 0, _len = _t.length; _i < _len; _i++) {
    event = _t[_i];
    this.push(event);
  }
  return this;
};

// Compute the CRC32 of a string
var table = '00000000 77073096 EE0E612C 990951BA 076DC419\n  706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B\n  7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D\n  6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F\n  63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1\n  4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3\n  45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5\n  56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87\n  58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589\n  06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB\n  086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED\n  1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF\n  15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541\n  3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73\n  33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525\n  206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17\n  2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739\n  9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B\n  9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D\n  806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F\n  8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1\n  A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3\n  A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795\n  BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7\n  B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9\n  EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B\n  E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD\n  F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF\n  F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661\n  D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53\n  DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605\n  CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37\n  C30C8EA1 5A05DF1B 2D02EF8D';

/* Number */
function crc32( /* String */str, /* Number */crc) {
  if (crc == undefined) crc = 0;
  var n = 0; // a number between 0 and 255
  var x = 0; // an hex number

  crc ^= -1;
  for (var i = 0, iTop = str.length; i < iTop; i++) {
    n = (crc ^ str.charCodeAt(i)) & 0xff;
    x = '0x' + table.substr(n * 9, 8);
    crc = crc >>> 8 ^ x;
  }
  return crc ^ -1;
}

function cdn_url(url, protocol) {
  // forcing https this way for backwards compat
  protocol = 'https://';

  var host = cdnUrls[Math.abs(crc32(url)) % cdnUrls.length];
  return protocol + host + url;
}

var _taggedTemplateLiteral = (function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
});

function request(url, opts) {
  var defaultOptions = {
    credentials: 'same-origin', // allow cookies to be sent
    headers: new Headers({
      'X-XSRF-TOKEN': getCSRFToken() })
  };

  var options = Object.assign({}, defaultOptions, opts);

  return fetch(url, options).then(function (response) {
    return response.json();
  });
}

function JsonToQueryString(json) {
  return Object.keys(json).map(function (key) {
    if (key.search(/\[\]/) !== -1 && json[key] instanceof Array) {
      return ArrayToQueryString(json[key], key);
    }

    var k = encodeURIComponent(key);
    var v = encodeURIComponent(json[key]);
    return k + '=' + v;
  }).join('&');
}

function ArrayToQueryString(arr, key) {
  var k = encodeURIComponent(key);
  return arr.map(function (value) {
    var v = encodeURIComponent(value);
    return k + '=' + v;
  }).join('&');
}

function JsonToFormData(json) {
  var data = new FormData();

  Object.keys(json).forEach(function (key) {
    data.append(key, json[key]);
  });

  return data;
}

function doPOSTRequest(url, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var defaultOptions = {
    method: 'POST',
    body: JsonToFormData(data)
  };

  var options = Object.assign({}, defaultOptions, opts);
  return request(url, options);
}

function doPOSTRequestUsingFormData(url, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var defaultOptions = {
    method: 'POST',
    body: data
  };

  var options = Object.assign({}, defaultOptions, opts);
  return request(url, options);
}

function doGETRequest(url, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var queryString = JsonToQueryString(data);
  var requestUrl = url + '?' + queryString;

  var defaultOptions = {
    method: 'GET'
  };

  var options = Object.assign({}, defaultOptions, opts);
  return request(requestUrl, options);
}

var _templateObject = _taggedTemplateLiteral(['/ajax/contest/projectAction/\n      getContestsInterestedIn.php'], ['/ajax/contest/projectAction/\n      getContestsInterestedIn.php']);

var ContestApi = function () {
  function ContestApi() {
    _classCallCheck(this, ContestApi);
  }

  _createClass(ContestApi, [{
    key: 'getContestHolderReputation',
    value: function getContestHolderReputation(data) {
      return doGETRequest('/ajax/reputation-employer-on-hover-content.php', data);
    }
  }, {
    key: 'getUsersPlanToJoin',
    value: function getUsersPlanToJoin(data) {
      return doGETRequest('/ajax/contest/projectAction/getContestJoins.php', data);
    }
  }, {
    key: 'joinContest',
    value: function joinContest(data) {
      return doPOSTRequest('/ajax/contest/projectAction/joinContest.php', data);
    }
  }, {
    key: 'bookMark',
    value: function bookMark(data) {
      return doPOSTRequest('/ajax/contest/watch.php', data);
    }
  }, {
    key: 'upgradeContest',
    value: function upgradeContest(data) {
      return doPOSTRequest('/ajax/contest/update.php', data);
    }
  }, {
    key: 'getExtendFees',
    value: function getExtendFees(data) {
      return doPOSTRequest('/ajax/contest/projectAction/getExtendedFees.php', data);
    }
  }, {
    key: 'getUserPaymentMethodInfo',
    value: function getUserPaymentMethodInfo(data) {
      return doPOSTRequest('/ajax/payment/getUserPaymentMethodInfo.php', data);
    }
  }, {
    key: 'getFirstWinner',
    value: function getFirstWinner(data) {
      return doGETRequest('/ajax/contest/projectAction/getFirstWinner.php', data);
    }
  }, {
    key: 'getEngagementData',
    value: function getEngagementData(data) {
      return doGETRequest('/ajax/contest/getEngagementData.php', data);
    }
  }, {
    key: 'getContestsInterestedIn',
    value: function getContestsInterestedIn(data) {
      return doGETRequest(oneLineTrim(_templateObject), data);
    }
  }, {
    key: 'unlockEntries',
    value: function unlockEntries(data) {
      return doGETRequest('/ajax/contest/projectAction/unlockEntries.php', data);
    }
  }, {
    key: 'pollVote',
    value: function pollVote(data) {
      return doPOSTRequest('/ajax/contest/pollVote.php', data);
    }
  }, {
    key: 'getContestEntryRequirements',
    value: function getContestEntryRequirements(data) {
      return doGETRequest('/ajax-api/contests/getContestEntryRequirements.php', data, {
        headers: getAuthHeader()
      });
    }
  }]);

  return ContestApi;
}();

var _templateObject$1 = _taggedTemplateLiteral(['/ajax/contest/projectAction/\n      getExtendBannerEligibility.php'], ['/ajax/contest/projectAction/\n      getExtendBannerEligibility.php']);

var EntryApi = function () {
  function EntryApi() {
    _classCallCheck(this, EntryApi);
  }

  _createClass(EntryApi, [{
    key: 'getEntries',
    value: function getEntries(data) {
      return doPOSTRequest('/ajax/contest/projectAction/getEntries.php', data);
    }
  }, {
    key: 'highlight',
    value: function highlight(data) {
      return doPOSTRequest('/ajax/contest/highlightEntry.php', data);
    }
  }, {
    key: 'getWinnerEntries',
    value: function getWinnerEntries(data) {
      return doGETRequest('/ajax/contest/projectAction/getWinnerEntries.php', data);
    }
  }, {
    key: 'getPendingHandoverEntries',
    value: function getPendingHandoverEntries(data) {
      return doGETRequest('/ajax/contest/projectAction/getPendingHandover.php', data);
    }
  }, {
    key: 'rate',
    value: function rate(data) {
      return doPOSTRequest('/ajax/contest/projectAction/rate.php', data);
    }
  }, {
    key: 'toggleLike',
    value: function toggleLike(data) {
      return doPOSTRequest('/ajax/contest/projectAction/toggleEntryLike.php', data);
    }
  }, {
    key: 'reject',
    value: function reject(data) {
      var requestData = Object.assign({}, data, {
        action: 'do'
      });
      return doPOSTRequest('/ajax/contest/projectAction/eliminate.php', requestData);
    }
  }, {
    key: 'reconsider',
    value: function reconsider(data) {
      var requestData = Object.assign({}, data, {
        action: 'undo'
      });
      return doPOSTRequest('/ajax/contest/projectAction/eliminate.php', requestData);
    }
  }, {
    key: 'award',
    value: function award(data) {
      return doPOSTRequest('/ajax/contest/projectAction/pick.php', data);
    }
  }, {
    key: 'withdraw',
    value: function withdraw(data) {
      var requestData = Object.assign({}, data, {
        action: 'do'
      });
      return doGETRequest('/ajax/contest/projectAction/withdraw.php', requestData);
    }
  }, {
    key: 'resubmit',
    value: function resubmit(data) {
      var requestData = Object.assign({}, data, {
        action: 'undo'
      });
      return doGETRequest('/ajax/contest/projectAction/withdraw.php', requestData);
    }
  }, {
    key: 'submit',
    value: function submit(data) {
      return doPOSTRequestUsingFormData('/ajax/contest/ajaxAddEntry.php', data);
    }
  }, {
    key: 'replaceFiles',
    value: function replaceFiles(entryId, fileNames) {
      var headers = new Headers(getAuthHeader());
      headers.append('Content-Type', 'application/json');

      return fetch('/api/contests/0.1/entries/' + entryId + '/files/', {
        method: 'PUT',
        body: JSON.stringify({
          file_names: fileNames
        }),
        headers: headers
      }).then(function (response) {
        return response.json();
      });
    }
  }, {
    key: 'getExtendBannerEligibility',
    value: function getExtendBannerEligibility(data) {
      return doGETRequest(oneLineTrim(_templateObject$1), data);
    }
  }, {
    key: 'buy',
    value: function buy(data) {
      return doPOSTRequest('/ajax/contest/projectAction/buy.php', data);
    }
  }, {
    key: 'editEntryPrice',
    value: function editEntryPrice(data) {
      return doPOSTRequest('/ajax/contest/editEntryPrice.php', data);
    }
  }, {
    key: 'getEntryIds',
    value: function getEntryIds(data) {
      return doGETRequest('/ajax/contest/projectAction/getEntryIds.php', data);
    }
  }, {
    key: 'getEntryInfo',
    value: function getEntryInfo(data) {
      return doGETRequest('/ajax/contest/projectAction/getEntryInfo.php', data);
    }
  }, {
    key: 'sendUserVerificationEmail',
    value: function sendUserVerificationEmail(data) {
      return doPOSTRequest('/users/resendcode.php', data);
    }
  }, {
    key: 'makeEntryPriceOffer',
    value: function makeEntryPriceOffer(data) {
      return doPOSTRequest('/ajax/contest/createEntryPriceOffer.php', data);
    }
  }, {
    key: 'acceptEntryPriceOffer',
    value: function acceptEntryPriceOffer(data) {
      return doPOSTRequest('/ajax/contest/acceptEntryPriceOffer.php', data);
    }
  }]);

  return EntryApi;
}();

var MessageApi = function () {
  function MessageApi() {
    _classCallCheck(this, MessageApi);
  }

  _createClass(MessageApi, [{
    key: 'getMessages',
    value: function getMessages(data) {
      return doGETRequest('/ajax/contest/projectAction/getMessages.php', data);
    }
  }, {
    key: 'postMessage',
    value: function postMessage(data) {
      return doPOSTRequest('/ajax/contest/projectAction/postMessage.php', data);
    }
  }, {
    key: 'deleteMessage',
    value: function deleteMessage(data) {
      var param = Object.assign({}, data, {
        action: 'delete'
      });
      return doPOSTRequest('/ajax/contest/projectAction/moderateMessage.php', param);
    }
  }, {
    key: 'updateMessage',
    value: function updateMessage(data) {
      return doPOSTRequest('/ajax/contest/updateMessage.php', data);
    }
  }]);

  return MessageApi;
}();

var CollaborationApi = function () {
  function CollaborationApi() {
    _classCallCheck(this, CollaborationApi);
  }

  _createClass(CollaborationApi, [{
    key: 'listCollaborations',
    value: function listCollaborations(data) {
      return doGETRequest('/ajax/contest/listCollaborators.php', data);
    }
  }, {
    key: 'addCollaborator',
    value: function addCollaborator(data) {
      return doPOSTRequest('/ajax/contest/addCollaborator.php', data);
    }
  }, {
    key: 'removeCollaborator',
    value: function removeCollaborator(data) {
      return doPOSTRequest('/ajax/contest/removeCollaborator.php', data);
    }
  }]);

  return CollaborationApi;
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var template$1 = "<div id=\"<%=  id  %>\" class=\"Modal <%=  extraClass  %>\" data-modal aria-hidden=\"<%=  hideModal  %>\">\n  <div class=\"Modal-inner\" <%  if (backdropClose) {  %> data-modal-outbound <%  }  %>>\n    <div class=\"Modal-dialog\" role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <%  if (closeButton) {  %>\n        <button class=\"Modal-close\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\">\n          <span class=\"Icon Icon--small\"><%=  uiIcon('ui-close')  %></span>\n        </button>\n        <%  }  %>\n        <%  if (header) {  %>\n        <header class=\"Modal-header\">\n          <%=  header  %>\n        </header>\n        <%  }  %>\n        <%  if (body) {  %>\n        <div class=\"Modal-body\">\n          <%=  body  %>\n        </div>\n        <%  }  %>\n        <%  if (footer) {  %>\n        <footer class=\"Modal-footer\">\n          <%=  footer  %>\n        </footer>\n        <%  }  %>\n      </div>\n    </div>\n  </div>\n  <div class=\"Modal-overlay\" tabindex=\"-1\"></div>\n</div>\n";

var OPEN_EVENT = {
  METHOD: 'method'
};

var CLOSE_EVENT = {
  ESC: 'esc',
  OUTOFBOUNDS: 'outofbounds',
  ELEMENT: 'element'
};

var defaultOptions = {
  main: document.querySelector('#main'),
  closeButton: true,
  backdropClose: true,
  extraClass: '',
  size: '',
  type: ''
};

// Template the modal's scaffolding by injecting header, body and footer
var scaffold = template(template$1);

/**
 * Modal constructor
 * @param {Node} node Dialog element
 * @param {Node} main Main element of the page
 */

var Modal = function () {
  /**
   * Modal constructor
   * @param  {String}   id                       An ID to apply to the modal.
   * @param  {Object}   content                  Content object to inject in the
   *                                             modal.
   * @param  {String}   content.header           Content for the header.
   * @param  {String}   content.body             Content for the body.
   * @param  {String}   content.footer           Content for the footer.
   * @param  {Object}   [options={}]             Options object for customise
   *                                             behaviour of modal.
   * @param  {Node}     [options.main]           An element to treat as the main
   *                                             content so that
   *                                             aria-hidden="true" can be
   *                                             toggled. Defaults to #main.
   * @param  {Boolean}  [options.closeButton]    Shows the x close button.
   *                                             Defaults to true.
   * @param  {Boolean}  [options.backdropClose]  Enables closing of modal via
   *                                             clicking on the backdrop.
   *                                             Defaults to true.
   * @param  {String}   [options.extraClass]     Adds extra classes to the
   *                                             modal.
   * @param  {String}   [options.size]           Sets the size of the modal.
   * @param  {String}   [options.type]           Sets the type of the modal.
   * @param  {Function} [options.onShow]         Callback function after showing
   *                                             the modal.
   * @param  {Function} [options.onHide]        Callback function after closing
   *                                             the modal.
   * @return {Modal}                             Modal instance.
   */
  function Modal(id, content, opts) {
    _classCallCheck(this, Modal);

    // Merge user options with defaultOptions
    var options = Object.assign({}, defaultOptions, opts);

    // Build configuration
    this.config = {
      id: id,
      content: {
        header: content.header,
        body: content.body,
        footer: content.footer
      },
      options: options
    };

    // Errors
    if (typeof this.config.id === 'undefined') {
      throw new TypeError('Modal id cannot be undefined.');
    }

    if (typeof this.config.content === 'undefined') {
      throw new TypeError('Modal content cannot be undefined.');
    }

    if (typeof this.config.options.main === 'undefined') {
      throw new TypeError('#main element does not exist.');
    }

    this.namespace = 'data-modal';
    this.body = document.body;
    this.main = this.config.options.main;

    // Appends markup to the body just before the </body>
    this.body.insertAdjacentHTML('beforeend', scaffold({
      uiIcon: uiIcon,
      id: this.config.id,
      hideModal: true,
      header: this.config.content.header,
      body: this.config.content.body,
      footer: this.config.content.footer,
      closeButton: this.config.options.closeButton,
      backdropClose: this.config.options.backdropClose,
      extraClass: this.config.options.extraClass + ' ' + (this.config.options.size + ' ') + ('' + this.config.options.type)
    }));

    this.node = document.getElementById(this.config.id);
    this.shown = false;

    this._bindEventsToModal();
    return this;
  }

  /**
   * Helper function that binds modal events to the modal element
   */

  _createClass(Modal, [{
    key: '_bindEventsToModal',
    value: function _bindEventsToModal() {
      var _this = this;

      // Bind show modal event to elements with <this.namespace>-show="<modal-id>"
      // data attributes
      Array.from(
      // Get all the elements with <this.namespace>-show="<modal-id>"
      document.querySelectorAll('[' + this.namespace + '-show="' + this.node.id + '"]')).forEach(function (opener) {
        opener.addEventListener('click', function () {
          return _this.show();
        });
      });

      // Bind hide modal event to elements with <this.namespace>-hide data
      // attributesmodules/membership/index.js
      Array.from(
      // Get all elements with <this.namespace>-hide inside the modal
      this.node.querySelectorAll('[' + this.namespace + '-hide]'))
      // Then combine it with all elements on the page that targets the modal
      // with <this.namespace>-hide="<modal-id>" for hiding
      .concat(Array.from(document.querySelectorAll('[' + this.namespace + '-hide="' + this.node.id + '"]'))).forEach(function (closer) {
        closer.addEventListener('click', function () {
          return _this.hide(CLOSE_EVENT.ELEMENT);
        });
      });

      // Hides modal when the user clicks out of bounds
      this.node.addEventListener('click', function (event) {
        if (event.target.hasAttribute(_this.namespace + '-outbound')) {
          _this.hide(CLOSE_EVENT.OUTOFBOUNDS);
        }
      });

      document.addEventListener('keydown', function (event) {
        // keydown on Esc key
        if (_this.shown && event.which === 27) {
          event.preventDefault();
          _this.hide(CLOSE_EVENT.ESC);
        }

        // keydown on Tab key
        if (_this.shown && event.which === 9) {
          _this._trapTabKey(_this.node, event);
        }
      });

      this.body.addEventListener('focus', function (event) {
        if (_this.shown && !_this.node.contains(event.target)) {
          _this._setFocusToFirstItem(_this.node);
        }
      }, true);
    }

    /**
     * Helper function to get all focusable children from a node
     * @param  {Node} node Node to look in
     * @return {Array}     Array of focusable nodes
     */

  }, {
    key: '_getFocusableChildren',
    value: function _getFocusableChildren(node) {
      var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];

      return Array.from(node.querySelectorAll(focusableElements.join(','))).filter(function (child) {
        return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
      });
    }

    /**
     * Helper function trapping the tab key inside a node
     * @param  {Node} node    Node to trap tab key in
     * @param  {Object} event Event to intercept
     */

  }, {
    key: '_trapTabKey',
    value: function _trapTabKey(node, event) {
      var focusableChildren = this._getFocusableChildren(node);
      var focusedItemIndex = focusableChildren.indexOf(document.activeElement);

      if (event.shiftKey && focusedItemIndex === 0) {
        focusableChildren[focusableChildren.length - 1].focus();
        event.preventDefault();
      } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
        focusableChildren[0].focus();
        event.preventDefault();
      }
    }

    /**
     * Helper function to focus first focusable item in node
     * @param {Node} node Node to search in for first focusable
     */

  }, {
    key: '_setFocusToFirstItem',
    value: function _setFocusToFirstItem(node) {
      var focusableChildren = this._getFocusableChildren(node);
      if (focusableChildren.length) focusableChildren[0].focus();
    }

    /**
     * Checks if scrollbar is visible.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_checkScrollbar',
    value: function _checkScrollbar() {
      var fullWindowWidth = window.innerWidth;

      this.bodyIsOverflowing = this.body.clientWidth < fullWindowWidth;
      this.scrollbarWidth = this._measureScrollbar();
    }

    /**
     * Sets the scrollbar padding offset on the body element.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_setScrollbar',
    value: function _setScrollbar() {
      var bodyPadding = parseInt(this.body.style.paddingRight || 0, 10);

      this.originalBodyPadding = this.body.style.paddingRight || '';

      if (this.bodyIsOverflowing) {
        this.body.style.paddingRight = '' + bodyPadding + this.scrollbarWidth + 'px';
      }
    }

    /**
     * Resets the padding on the body to the way it was with the scrollbar.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_resetScrollbar',
    value: function _resetScrollbar() {
      this.body.style.paddingRight = this.originalBodyPadding;
    }

    /**
     * Measures the width of the scrollbar.
     * Ported from the bootstrap v3.3.6.
     *
     * @return {Number} Width of the scrollbar.
     */

  }, {
    key: '_measureScrollbar',
    value: function _measureScrollbar() {
      var scrollDiv = document.createElement('div');
      // Injects some styling to the element which forces the display of a scroll
      // bar and places it off the page to ensure it is never visible.
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '100px';
      scrollDiv.style.height = '100px';

      this.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      this.body.removeChild(scrollDiv);
      return scrollbarWidth;
    }

    /**
     * Show the modal with optional eventType identifier
     * @param  {String} eventType An identifier string to pass into the onShow
     *                            callback method.
     */

  }, {
    key: 'show',
    value: function show(eventType) {
      this.shown = true;
      this._checkScrollbar();
      this._setScrollbar();
      this.body.setAttribute(this.namespace + '-open', '');
      this.node.removeAttribute('aria-hidden');
      this.main.setAttribute('aria-hidden', 'true');
      this.focusedBeforeDialog = document.activeElement;
      this._setFocusToFirstItem(this.node);
      eventType = eventType || OPEN_EVENT.METHOD;

      if (this.config.options.onShow) {
        this.config.options.onShow(eventType);
      }
    }

    /**
     * Hide the modal
     * @param  {String} eventType An identifier string to pass into the onHide
     *                            callback method.
     */

  }, {
    key: 'hide',
    value: function hide(eventType) {
      this.shown = false;
      this._resetScrollbar();
      this.body.removeAttribute(this.namespace + '-open', '');
      this.node.setAttribute('aria-hidden', 'true');
      this.main.removeAttribute('aria-hidden');
      this.focusedBeforeDialog.focus();

      if (this.config.options.onHide) {
        this.config.options.onHide(eventType);
      }
    }

    /**
     * Dynamically change the template of the modal given the new template.
     * Use this if you want to change the content without creating a new modal
     * as this does not automatically hide the new content upon replacement
     *
     * @param  {Object} content Content object to inject in the modal.
     */

  }, {
    key: 'replaceTemplate',
    value: function replaceTemplate(content) {
      var newModalContent = scaffold({
        uiIcon: uiIcon,
        id: this.config.id,
        hideModal: false,
        header: content.header,
        body: content.body,
        footer: content.footer,
        closeButton: this.config.options.closeButton,
        backdropClose: this.config.options.backdropClose,
        extraClass: this.config.options.extraClass + ' ' + (this.config.options.size + ' ') + ('' + this.config.options.type)
      });

      // convert content to nodes
      var newModal = document.createElement('div');
      newModal.innerHTML = newModalContent;
      var newTemplate = newModal.childNodes[0];

      // replace with new template
      var fragment = document.createDocumentFragment();
      Array.prototype.forEach.call(newTemplate.children, function (child) {
        var childNode = child instanceof Node ? child : document.createTextNode(String(child));
        fragment.appendChild(childNode);
      });

      this.node.replaceChild(fragment, this.node.children[0]);

      // bind modal events
      this.node = document.getElementById(this.config.id);
      this._bindEventsToModal();
    }
  }]);

  return Modal;
}();

var infractionFormHeaderTemplate = "<div class=\"Card-header InfractionsModal-header\">\n  <h3><%=  title  %></h3>\n</div>\n";

var infractionFormBodyTemplate = "<div class=\"Card-body InfractionsModal-body\">\n  <form class=\"fl-form InfractionsModal-form\">\n      <legend><%=  bodyTitle  %></legend>\n\n      <%  if (error) {  %>\n        <div class=\"alert alert-error \">\n          <span class=\"Icon InfractionsModal-icon--error\">\n              <%=  uiIcon('ui-warning')  %>\n          </span>\n          <strong><%- T_('오류가 발생했습니다.') %></strong>\n          <span><%- T_('다시 시도하여 주십시오.') %></span>\n        </div>\n      <%  }  %>\n\n    <fieldset>\n      <ol>\n        <li class=\"form-step\">\n          <%  if (options.length > 0) {  %>\n            <div class=\"Radio Radio--vertical InfractionsModal-options\">\n              <%  options.forEach(function(option) {  %>\n                <input\n                  id=\"infraction-<%=  option.id  %>\"\n                  class=\"Radio-input InfractionsModal-option\"\n                  type=\"radio\"\n                  name=\"<%=  optionName  %>\"\n                  value=\"<%=  option.id  %>\"\n                  <%  if (option.id === category || option.id === violation) {  %>\n                    checked\n                  <%  }  %>\n                  >\n                <label class=\"Radio-label InfractionsModal-option-label\" for=\"infraction-<%=  option.id  %>\">\n                  <%=  option.type  %>\n                </label>\n              <%  });  %>\n            </div>\n          <%  } else {  %>\n            <textarea\n              class=\"default-textarea InfractionsModal-comments\"\n              placeholder=\"<%=  textAreaPlaceholder  %>\"\n              cols=\"50\"\n              rows=\"5\"\n            ><%=  comments  %></textarea>\n          <%  }  %>\n        </li>\n      </ol>\n    </fieldset>\n  </form>\n</div>\n";

var infractionFormFooterTemplate = "<div class=\"Card-footer--simple InfractionsModal-footer\">\n  <%  if ((optionName && optionName == 'infractionCategory') || (optionName && optionName === 'infractionType' && defaultInfractionCategory)) {  %>\n    <button type=\"button\" class=\"btn\" data-modal-hide><%- T_('취소') %></button>\n  <%  } else {  %>\n    <button type=\"button\" class=\"btn InfractionsModal-back\"><%- T_('뒤로') %></button>\n  <%  }  %>\n\n  <button\n    type=\"button\"\n    class=\"btn btn-info InfractionsModal-next\"\n    <%  if (disableNext) {  %>\n      disabled\n    <%  }  %>\n    >\n    <%- T_('계속') %>\n  </button>\n</div>\n";

var infractionSuccessHeaderTemplate = "<div class=\"Card-header InfractionsModal-header\">\n  <h3><%=  title  %></h3>\n</div>\n";

var infractionSuccessBodyTemplate = "<div class=\"Card-body InfractionsModal-body\">\n  <h5><%=  bodyTitle  %></h5>\n  <p><%=  body  %></p>\n</div>\n";

var infractionSuccessFooterTemplate = "<div class=\"Card-footer--simple InfractionsModal-footer\">\n  <%  if (goToUrl != null) {  %>\n    <a href=\"<%=  goToUrl  %>\" class=\"btn btn-primary\"><%- T_('계속') %></a>\n  <%  } else {  %>\n    <button type=\"button\" class=\"btn\" data-modal-hide><%- T_('완료!') %></button>\n  <%  }  %>\n</div>\n";

var _templateObject$2 = _taggedTemplateLiteral(['\uBB34\uC2A8 \uC77C\uC778\uC9C0, \uC800\uD76C\uAC00 \uC774\uD574\uD560 \uC218 \uC788\uB3C4\uB85D \uB3C4\uC6C0\uC744 \uBD80\uD0C1\uB4DC\uB9BD\uB2C8\uB2E4.'], ['\uBB34\uC2A8 \uC77C\uC778\uC9C0, \uC800\uD76C\uAC00 \uC774\uD574\uD560 \uC218 \uC788\uB3C4\uB85D \uB3C4\uC6C0\uC744 \uBD80\uD0C1\uB4DC\uB9BD\uB2C8\uB2E4.']),
    _templateObject2 = _taggedTemplateLiteral(['\uBB34\uC2A8 \uC77C\uC774 \uBC8C\uC5B4\uC9C0\uACE0 \uC788\uB294 \uAC83\uC785\uB2C8\uAE4C?'], ['\uBB34\uC2A8 \uC77C\uC774 \uBC8C\uC5B4\uC9C0\uACE0 \uC788\uB294 \uAC83\uC785\uB2C8\uAE4C?']),
    _templateObject3 = _taggedTemplateLiteral(['\uC9C0\uBD88 \uC218\uB2E8\uC774\uB098 \uB300\uD654 \uC218\uB2E8\uC744 Freelancer \uC774\uC678\uC5D0 \uB2E4\uB978 \uC0AC\uC774\uD2B8\uB85C \uC62E\uACA8 \uAC00\uB824\uACE0 \uD569\uB2C8\uB2E4.'], ['\uC9C0\uBD88 \uC218\uB2E8\uC774\uB098 \uB300\uD654 \uC218\uB2E8\uC744 Freelancer \uC774\uC678\uC5D0 \uB2E4\uB978 \uC0AC\uC774\uD2B8\uB85C \uC62E\uACA8 \uAC00\uB824\uACE0 \uD569\uB2C8\uB2E4.']),
    _templateObject4 = _taggedTemplateLiteral(['\uD504\uB85C\uD544 \uC815\uBCF4\uC5D0 \uC624\uD574\uD560 \uB9CC\uD55C \uB0B4\uC6A9\uC774\uB098 \uC798\uBABB\uB41C \uB0B4\uC6A9\uC744 \uC62C\uB824 \uB193\uACE0 \uC788\uC2B5\uB2C8\uB2E4.'], ['\uD504\uB85C\uD544 \uC815\uBCF4\uC5D0 \uC624\uD574\uD560 \uB9CC\uD55C \uB0B4\uC6A9\uC774\uB098 \uC798\uBABB\uB41C \uB0B4\uC6A9\uC744 \uC62C\uB824 \uB193\uACE0 \uC788\uC2B5\uB2C8\uB2E4.']),
    _templateObject5 = _taggedTemplateLiteral(['\uBD80\uC801\uC808\uD558\uAC70\uB098 \uBAA8\uC695\uC801\uC778 \uD589\uB3D9\uC744 \uBCF4\uC774\uACE0 \uC788\uC2B5\uB2C8\uB2E4.'], ['\uBD80\uC801\uC808\uD558\uAC70\uB098 \uBAA8\uC695\uC801\uC778 \uD589\uB3D9\uC744 \uBCF4\uC774\uACE0 \uC788\uC2B5\uB2C8\uB2E4.']),
    _templateObject6 = _taggedTemplateLiteral(['\uD574\uB2F9 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBB38\uC81C\uAC00 \uC880 \uC788\uC5C8\uC2B5\uB2C8\uB2E4.'], ['\uD574\uB2F9 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBB38\uC81C\uAC00 \uC880 \uC788\uC5C8\uC2B5\uB2C8\uB2E4.']),
    _templateObject7 = _taggedTemplateLiteral(['\uB2E4\uB978 \uC791\uC5C5 \uACB0\uACFC\uB97C \uBCF5\uC81C\uD558\uC5EC \uC81C\uCD9C\uD558\uC600\uC2B5\uB2C8\uB2E4.'], ['\uB2E4\uB978 \uC791\uC5C5 \uACB0\uACFC\uB97C \uBCF5\uC81C\uD558\uC5EC \uC81C\uCD9C\uD558\uC600\uC2B5\uB2C8\uB2E4.']),
    _templateObject8 = _taggedTemplateLiteral(['\uC774 \uC77C\uC744 \uC5B4\uB5BB\uAC8C \uCC98\uB9AC\uD558\uACE0 \uC788\uC2B5\uB2C8\uAE4C?'], ['\uC774 \uC77C\uC744 \uC5B4\uB5BB\uAC8C \uCC98\uB9AC\uD558\uACE0 \uC788\uC2B5\uB2C8\uAE4C?']),
    _templateObject9 = _taggedTemplateLiteral(['\uC774 \uC77C\uC774 \uC5B8\uC81C \uC5B4\uB514\uC11C \uC77C\uC5B4\uB0AC\uB294\uC9C0 \uC790\uC138\uD558\uAC8C \uC124\uBA85\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624.'], ['\uC774 \uC77C\uC774 \uC5B8\uC81C \uC5B4\uB514\uC11C \uC77C\uC5B4\uB0AC\uB294\uC9C0 \uC790\uC138\uD558\uAC8C \uC124\uBA85\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624.']),
    _templateObject10 = _taggedTemplateLiteral(['\uBB38\uC81C\uB294...'], ['\uBB38\uC81C\uB294...']),
    _templateObject11 = _taggedTemplateLiteral(['\uC800\uD76C\uC5D0\uAC8C \uC774 \uC77C\uC744 \uC54C\uB824 \uC8FC\uC154\uC11C \uB300\uB2E8\uD788 \uAC10\uC0AC\uD569\uB2C8\uB2E4.'], ['\uC800\uD76C\uC5D0\uAC8C \uC774 \uC77C\uC744 \uC54C\uB824 \uC8FC\uC154\uC11C \uB300\uB2E8\uD788 \uAC10\uC0AC\uD569\uB2C8\uB2E4.']),
    _templateObject12 = _taggedTemplateLiteral(['\uC88B\uC740 \uC18C\uC2DD\uC774 \uC788\uC2B5\uB2C8\uB2E4!'], ['\uC88B\uC740 \uC18C\uC2DD\uC774 \uC788\uC2B5\uB2C8\uB2E4!']),
    _templateObject13 = _taggedTemplateLiteral(['\uACE0\uAC1D\uB2D8\uC758 \uC2E0\uACE0 \uB0B4\uC6A9\uC740 \uC800\uD76C\uAC00 \uC811\uC218\uD558\uC600\uC73C\uBA70, \uACE7 \uC774\uC5D0 \uB530\uB978 \uC870\uC0AC \uD65C\uB3D9 \uBC0F \uD6C4\uC18D \uC870\uCE58\uB97C \uCDE8\uD558\uB3C4\uB85D \uD558\uACA0\uC2B5\uB2C8\uB2E4.'], ['\uACE0\uAC1D\uB2D8\uC758 \uC2E0\uACE0 \uB0B4\uC6A9\uC740 \uC800\uD76C\uAC00 \uC811\uC218\uD558\uC600\uC73C\uBA70, \uACE7 \uC774\uC5D0 \uB530\uB978 \uC870\uC0AC \uD65C\uB3D9 \uBC0F \uD6C4\uC18D \uC870\uCE58\uB97C \uCDE8\uD558\uB3C4\uB85D \uD558\uACA0\uC2B5\uB2C8\uB2E4.']),
    _templateObject14 = _taggedTemplateLiteral(['\uC0C1\uB300\uBC29\uC5D0\uC11C Freelancer.com \uC0AC\uC774\uD2B8\uB97C \uD1B5\uD55C \uC9C0\uBD88\uBCF4\uB2E4, \uC790\uC2E0\uC758 \uD398\uC774\uD314 \uACC4\uC815\uC73C\uB85C \uC9C0\uBD88\uD574 \uB2EC\uB77C\uB294 \uC694\uCCAD\uC744 \uBC18\uBCF5\uC801\uC73C\uB85C \uD574 \uC654\uC73C\uBA70, \uB0B4 \uCC44\uD305 \uAE30\uB85D\uC758 4\uC6D4 24\uC77C\uC790 \uC790\uB8CC\uC5D0\uC11C \uD655\uC778\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'], ['\uC0C1\uB300\uBC29\uC5D0\uC11C Freelancer.com \uC0AC\uC774\uD2B8\uB97C \uD1B5\uD55C \uC9C0\uBD88\uBCF4\uB2E4, \uC790\uC2E0\uC758 \uD398\uC774\uD314 \uACC4\uC815\uC73C\uB85C \uC9C0\uBD88\uD574 \uB2EC\uB77C\uB294 \uC694\uCCAD\uC744 \uBC18\uBCF5\uC801\uC73C\uB85C \uD574 \uC654\uC73C\uBA70, \uB0B4 \uCC44\uD305 \uAE30\uB85D\uC758 4\uC6D4 24\uC77C\uC790 \uC790\uB8CC\uC5D0\uC11C \uD655\uC778\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.']),
    _templateObject15 = _taggedTemplateLiteral(['\uC5B4\uB5BB\uAC8C \uD574\uC11C \uD574\uB2F9 \uC0AC\uD56D\uC744 \uC18D\uC784\uC218\uB85C \uD310\uB2E8\uD558\uC168\uB294\uC9C0, \uADF8 \uB0B4\uC6A9\uC744 \uC785\uB825\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624.'], ['\uC5B4\uB5BB\uAC8C \uD574\uC11C \uD574\uB2F9 \uC0AC\uD56D\uC744 \uC18D\uC784\uC218\uB85C \uD310\uB2E8\uD558\uC168\uB294\uC9C0, \uADF8 \uB0B4\uC6A9\uC744 \uC785\uB825\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624.']),
    _templateObject16 = _taggedTemplateLiteral(['\uC790\uC2E0\uC758 \uD504\uB85C\uD544 \uC815\uBCF4\uC5D0\uB294 \uD30C\uC774\uC36C\uC5D0 \uC815\uD1B5\uD55C \uC2E4\uB825\uC774 \uC788\uB2E4\uACE0 \uD588\uC73C\uB098, \uB9C9\uC0C1 \uD30C\uC774\uC36C\uC73C\uB85C \'\uD5EC\uB85C\uC6B0 \uC6D4\uB4DC\' \uD504\uB85C\uADF8\uB7A8\uC870\uCC28\uB3C4 \uCF54\uB529\uD560 \uC904 \uBAB0\uB790\uC2B5\uB2C8\uB2E4.'], ['\uC790\uC2E0\uC758 \uD504\uB85C\uD544 \uC815\uBCF4\uC5D0\uB294 \uD30C\uC774\uC36C\uC5D0 \uC815\uD1B5\uD55C \uC2E4\uB825\uC774 \uC788\uB2E4\uACE0 \uD588\uC73C\uB098, \uB9C9\uC0C1 \uD30C\uC774\uC36C\uC73C\uB85C \'\uD5EC\uB85C\uC6B0 \uC6D4\uB4DC\' \uD504\uB85C\uADF8\uB7A8\uC870\uCC28\uB3C4 \uCF54\uB529\uD560 \uC904 \uBAB0\uB790\uC2B5\uB2C8\uB2E4.']),
    _templateObject17 = _taggedTemplateLiteral(['\uC11C\uB85C \uC758\uB17C\uD558\uB294 \uC790\uB9AC\uC5D0\uC11C \uBD80\uC801\uC808\uD55C \uC5B8\uC5B4\uB97C \uC0AC\uC6A9\uD558\uC600\uC73C\uBA70, \uC774\uC640 \uAD00\uB828\uD55C \uB0B4\uC6A9\uC740 \uCD5C\uADFC\uC758 \uCC44\uD305 \uB0B4\uC5ED\uC5D0\uC11C \uD655\uC778\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'], ['\uC11C\uB85C \uC758\uB17C\uD558\uB294 \uC790\uB9AC\uC5D0\uC11C \uBD80\uC801\uC808\uD55C \uC5B8\uC5B4\uB97C \uC0AC\uC6A9\uD558\uC600\uC73C\uBA70, \uC774\uC640 \uAD00\uB828\uD55C \uB0B4\uC6A9\uC740 \uCD5C\uADFC\uC758 \uCC44\uD305 \uB0B4\uC5ED\uC5D0\uC11C \uD655\uC778\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.']),
    _templateObject18 = _taggedTemplateLiteral(['\uD574\uB2F9 \uBB38\uC81C\uC810\uC5D0 \uB300\uD55C \uC124\uBA85\uC744 \uC785\uB825\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624.'], ['\uD574\uB2F9 \uBB38\uC81C\uC810\uC5D0 \uB300\uD55C \uC124\uBA85\uC744 \uC785\uB825\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624.']),
    _templateObject19 = _taggedTemplateLiteral(['\uBE44\uC724\uB9AC\uC801\uC778 \uD504\uB85C\uC81D\uD2B8\uC600\uAC70\uB098, \uD504\uB85C\uC81D\uD2B8\uC758 \uB9C8\uC77C \uC2A4\uD1A4 \uAD00\uB828\uD558\uC5EC \uBD84\uC7C1 \uBB38\uC81C\uAC00 \uC788\uC5C8\uC2B5\uB2C8\uB2E4.'], ['\uBE44\uC724\uB9AC\uC801\uC778 \uD504\uB85C\uC81D\uD2B8\uC600\uAC70\uB098, \uD504\uB85C\uC81D\uD2B8\uC758 \uB9C8\uC77C \uC2A4\uD1A4 \uAD00\uB828\uD558\uC5EC \uBD84\uC7C1 \uBB38\uC81C\uAC00 \uC788\uC5C8\uC2B5\uB2C8\uB2E4.']),
    _templateObject20 = _taggedTemplateLiteral(['\uC791\uC5C5 \uACB0\uACFC \uBCF5\uC81C \uACFC\uC815\uC5D0 \uB300\uD574 \uC880 \uB354 \uC790\uC138\uD55C \uC124\uBA85\uC744 \uC785\uB825\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624.'], ['\uC791\uC5C5 \uACB0\uACFC \uBCF5\uC81C \uACFC\uC815\uC5D0 \uB300\uD574 \uC880 \uB354 \uC790\uC138\uD55C \uC124\uBA85\uC744 \uC785\uB825\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624.']),
    _templateObject21 = _taggedTemplateLiteral(['\uD574\uB2F9 \uC751\uBAA8\uC791\uC740 \uC5EC\uAE30(https://www.freelancer.com/contestentry/12345)\uC5D0 \uC788\uC73C\uBA70, \uB2E4\uB978 \uC791\uC5C5 \uACB0\uACFC(http://stockimages.com/12345)\uB97C \uBA85\uBC31\uD788 \uBCF5\uC81C\uD55C \uAC83\uC785\uB2C8\uB2E4.'], ['\uD574\uB2F9 \uC751\uBAA8\uC791\uC740 \uC5EC\uAE30(https://www.freelancer.com/contestentry/12345)\uC5D0 \uC788\uC73C\uBA70, \uB2E4\uB978 \uC791\uC5C5 \uACB0\uACFC(http://stockimages.com/12345)\uB97C \uBA85\uBC31\uD788 \uBCF5\uC81C\uD55C \uAC83\uC785\uB2C8\uB2E4.']),
    _templateObject22 = _taggedTemplateLiteral(['\uC5B4\uB5A4 \uBB38\uC81C\uAC00 \uC788\uB294\uC9C0 \uC124\uBA85\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624.'], ['\uC5B4\uB5A4 \uBB38\uC81C\uAC00 \uC788\uB294\uC9C0 \uC124\uBA85\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624.']),
    _templateObject23 = _taggedTemplateLiteral(['\uC608: \uADF8 \uCABD\uC758 \uC751\uBAA8\uC791(https://www.freelancer.com/contestentry/12345)\uC744 \uD655\uC778\uD574 \uBCF4\uB2C8, \uB2E4\uB978 \uC751\uBAA8\uC791(http://stockimages.com/12345)\uC744 \uD45C\uC808\uD55C \uAC83\uC774 \uBA85\uBC31\uD569\uB2C8\uB2E4.'], ['\uC608: \uADF8 \uCABD\uC758 \uC751\uBAA8\uC791(https://www.freelancer.com/contestentry/12345)\uC744 \uD655\uC778\uD574 \uBCF4\uB2C8, \uB2E4\uB978 \uC751\uBAA8\uC791(http://stockimages.com/12345)\uC744 \uD45C\uC808\uD55C \uAC83\uC774 \uBA85\uBC31\uD569\uB2C8\uB2E4.']),
    _templateObject24 = _taggedTemplateLiteral(['\uC5B4\uB5A4 \uBB38\uC81C\uAC00 \uC788\uB294\uC9C0 \uC124\uBA85\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624. (\uC120\uD0DD\uC0AC\uD56D)'], ['\uC5B4\uB5A4 \uBB38\uC81C\uAC00 \uC788\uB294\uC9C0 \uC124\uBA85\uD558\uC5EC \uC8FC\uC2ED\uC2DC\uC624. (\uC120\uD0DD\uC0AC\uD56D)']),
    _templateObject25 = _taggedTemplateLiteral(['\uC774\uC640 \uAC19\uC740 \uBB38\uC81C\uC810\uC744 \uD574\uACB0\uD558\uB294 \uCD5C\uC801\uC758 \uBC29\uBC95\uC740 \uD574\uB2F9 \uB9C8\uC77C\uC2A4\uD1A4 \uAD00\uB828\uD558\uC5EC \uBD84\uC7C1 \uBB38\uC81C\uB97C \uC81C\uAE30\uD558\uB294 \uAC83\uC785\uB2C8\uB2E4. \uC544\uB798\uC5D0\uC11C \uACC4\uC18D \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC2DC\uBA74, \uBC14\uB85C \uBD84\uC7C1\uC744 \uC2DC\uC791\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'], ['\uC774\uC640 \uAC19\uC740 \uBB38\uC81C\uC810\uC744 \uD574\uACB0\uD558\uB294 \uCD5C\uC801\uC758 \uBC29\uBC95\uC740 \uD574\uB2F9 \uB9C8\uC77C\uC2A4\uD1A4 \uAD00\uB828\uD558\uC5EC \uBD84\uC7C1 \uBB38\uC81C\uB97C \uC81C\uAE30\uD558\uB294 \uAC83\uC785\uB2C8\uB2E4. \uC544\uB798\uC5D0\uC11C \uACC4\uC18D \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC2DC\uBA74, \uBC14\uB85C \uBD84\uC7C1\uC744 \uC2DC\uC791\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.']),
    _templateObject26 = _taggedTemplateLiteral(['\uC800\uD76C\uB294 \uD574\uB2F9 \uC0AC\uC6A9\uC790 \uACC4\uC815\uC744 \uC870\uC0AC\uD560 \uC608\uC815\uC774\uBA70, \uAE30\uC5C5\uD615 \uC11C\uBE44\uC2A4 \uC6A9\uB3C4\uB85C \uBCC4\uB3C4 \uD45C\uC2DD\uC744 \uD574 \uB450\uACA0\uC2B5\uB2C8\uB2E4.'], ['\uC800\uD76C\uB294 \uD574\uB2F9 \uC0AC\uC6A9\uC790 \uACC4\uC815\uC744 \uC870\uC0AC\uD560 \uC608\uC815\uC774\uBA70, \uAE30\uC5C5\uD615 \uC11C\uBE44\uC2A4 \uC6A9\uB3C4\uB85C \uBCC4\uB3C4 \uD45C\uC2DD\uC744 \uD574 \uB450\uACA0\uC2B5\uB2C8\uB2E4.']);

var InfractionsModal = function () {
  /**
                                        * Modal constructor. Initializes the modal to show the category step.
                                        */
  function InfractionsModal(infractionTypes, sourceId, options) {
    _classCallCheck(this, InfractionsModal);

    this.infraction = {
      category: '',
      violation: '',
      comments: '' };

    this.infractionTypes = infractionTypes;
    this.sourceId = sourceId;
    this.session = getCookie('_tracking_session');
    this.options = options;

    if (this.options.context) {
      this.contextName = this.options.context + '_id';
    } else {
      this.contextName = 'reportee_user_id';
    }

    this.infractionTypesIdLookUp = {
      USER_IS_AN_ORGANIZATION: '7',
      PROJECT_ISSUE_WITH_USER: '10',
      OTHER: '12' };

    this.modalOptions = {
      getCategory: {
        title: translate(_templateObject$2),
        bodyTitle: translate(_templateObject2),
        options: [{
          id: 'contactInfo',
          type: translate(_templateObject3) }, {
          id: 'profile',
          type: translate(_templateObject4) }, {
          id: 'behavior',
          type: translate(_templateObject5) }, {
          id: 'project',
          type: translate(_templateObject6) }, {
          id: 'copyright',
          type: translate(_templateObject7) }, this.infractionTypes[11]],

        optionName: 'infractionCategory',
        error: false },

      getType: {
        title: translate(_templateObject$2),
        bodyTitle: translate(_templateObject8),
        options: [],
        optionName: 'infractionType',
        textAreaPlaceholder: '',
        error: false },

      getComments: {
        title: translate(_templateObject$2),
        bodyTitle: translate(_templateObject9),
        optionName: 'infractionComments',
        options: [],
        textAreaPlaceholder: translate(_templateObject10),
        error: false },

      submitted: {},

      defaultSubmitted: {
        title: translate(_templateObject11),
        goToUrl: null,
        bodyTitle: translate(_templateObject12),
        body: translate(_templateObject13) } };

    this.modalId = 'infraction-modal-id';

    if (this.options.defaultInfractionCategory) {
      this.state = 'getInfractionType';
      this.infraction.category = this.options.defaultInfractionCategory;
      this.changeModalContentBasedOnInfractionCategory();

      this.setCurrentModalTemplate();
      this.initializeModal();

      this.modalOptions.submitted = _extends({}, this.modalOptions.defaultSubmitted);
      this.bindGetInfractionTypeModalEvents();
    } else {
      this.state = 'getInfractionCategory';

      this.setCurrentModalTemplate();
      this.initializeModal();

      this.modalOptions.submitted = _extends({}, this.modalOptions.defaultSubmitted);
      this.bindGetInfractionCategoryModalEvents();
    }
  }

  /**
     * Instantiates the modal class.
     */

  _createClass(InfractionsModal, [{
    key: 'initializeModal',
    value: function initializeModal() {
      var _this = this;

      this.modal = new Modal(this.modalId, this.modalContent, {
        extraClass: 'InfractionsModal',
        onShow: function onShow() {
          _this.setCurrentModalTemplate();
          _this.switchModalContent();
          if (typeof _this.options.onShowCallback === 'function') {
            _this.options.onShowCallback();
          }
        },
        onHide: function onHide() {
          if (typeof _this.options.onHideCallback === 'function') {
            _this.options.onHideCallback();
          }
        } });
    }

    /**
       * Changes modal conent based on the option chosen in the category step.
       */

  }, {
    key: 'changeModalContentBasedOnInfractionCategory',
    value: function changeModalContentBasedOnInfractionCategory() {
      switch (this.infraction.category) {
        case 'contactInfo':
          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject9),
            textAreaPlaceholder: translate(_templateObject14) });

          this.modalOptions.getType.options = [this.infractionTypes[0], this.infractionTypes[1], this.infractionTypes[2]];

          break;

        case 'profile':
          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject15),
            textAreaPlaceholder: translate(_templateObject16) });

          this.modalOptions.getType.options = [this.infractionTypes[3], this.infractionTypes[4], this.infractionTypes[5], this.infractionTypes[6]];

          break;

        case 'behavior':
          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject9),
            textAreaPlaceholder: translate(_templateObject17) });

          this.modalOptions.getType.options = [this.infractionTypes[7], this.infractionTypes[8]];

          break;

        case 'project':
          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject18),
            textAreaPlaceholder: translate(_templateObject19) });

          this.modalOptions.getType.options = [this.infractionTypes[9], this.infractionTypes[10]];

          break;

        case 'copyright':
          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject20),
            textAreaPlaceholder: translate(_templateObject21) });

          this.modalOptions.getType.options = [this.infractionTypes[12], this.infractionTypes[13]];

          break;

        case 'contestEntry':
          this.modalOptions.getType = _extends({}, this.modalOptions.getType, {
            bodyTitle: translate(_templateObject2),
            options: [this.infractionTypes[12], this.infractionTypes[13], this.infractionTypes[16], this.infractionTypes[14], this.infractionTypes[15], this.infractionTypes[11]] });

          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject22),
            textAreaPlaceholder: translate(_templateObject23) });

          break;

        case 'contestMessage':
          this.modalOptions.getType = _extends({}, this.modalOptions.getType, {
            bodyTitle: translate(_templateObject2),
            options: [this.infractionTypes[2], this.infractionTypes[8], this.infractionTypes[11]] });

          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject24) });

          break;

        default:
          break;}

      if (this.infraction.violation === this.infractionTypesIdLookUp.OTHER) {
        this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
          bodyTitle: translate(_templateObject18),
          textAreaPlaceholder: translate(_templateObject10) });
      }
    }

    /**
       * Changes modal conent based on the option chosen in the infraction type.
       */

  }, {
    key: 'changeModalContentBasedOnInfractionType',
    value: function changeModalContentBasedOnInfractionType() {
      if (this.infraction.violation == this.infractionTypesIdLookUp.PROJECT_ISSUE_WITH_USER) {
        this.modalOptions.submitted = _extends({}, this.modalOptions.defaultSubmitted, {
          goToUrl: '/dispute/disputeslist.php',
          bodyTitle: '',
          body: translate(_templateObject25) });
      } else if (this.infraction.violation == this.infractionTypesIdLookUp.USER_IS_AN_ORGANIZATION) {
        this.modalOptions.submitted = _extends({}, this.modalOptions.defaultSubmitted, {
          bodyTitle: '',
          body: translate(_templateObject26) });
      } else {
        this.modalOptions.submitted = _extends({}, this.modalOptions.defaultSubmitted);
      }
    }

    /**
       * Switches the modal content based on the current state.
       * This creates a new template for the modal, replacing the current one,
       * and binds the event listeners to the new content.
       *
       * @param {Boolean} error Toggle for showing error
       */

  }, {
    key: 'switchModalContent',
    value: function switchModalContent() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.setCurrentModalTemplate(error);
      this.modal.replaceTemplate(this.modalContent);

      switch (this.state) {
        case 'getInfractionCategory':
          this.bindGetInfractionCategoryModalEvents();
          break;
        case 'getInfractionType':
          this.bindGetInfractionTypeModalEvents();
          break;
        case 'getInfractionComments':
          this.bindGetInfractionCommentsModalEvents();
          break;
        default:
          break;}
    }

    /**
       * Sets the modal template to be used based on the current state.
       *
       * @param {Boolean} error Toggle for showing error
       */

  }, {
    key: 'setCurrentModalTemplate',
    value: function setCurrentModalTemplate() {
      var _this2 = this;

      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var currentModalOptions = void 0;

      switch (this.state) {
        case 'getInfractionCategory':
          currentModalOptions = this.modalOptions.getCategory;
          break;
        case 'getInfractionType':
          currentModalOptions = this.modalOptions.getType;
          break;
        case 'getInfractionComments':
          currentModalOptions = this.modalOptions.getComments;
          break;
        case 'infractionSubmitted':
          currentModalOptions = this.modalOptions.submitted;
          break;
        default:
          break;}

      var modalOptions = _extends({
        uiIcon: uiIcon,
        T_: translate,
        defaultInfractionCategory: this.options.defaultInfractionCategory
      }, currentModalOptions, this.infraction);

      if (this.state === 'infractionSubmitted') {
        this.modalContent = {
          header: template(infractionSuccessHeaderTemplate)(modalOptions),
          body: template(infractionSuccessBodyTemplate)(modalOptions),
          footer: template(infractionSuccessFooterTemplate)(modalOptions) };
      } else {
        // disable next button only when there are no options or comments
        var noComments = modalOptions.optionName === 'infractionComments' && modalOptions.comments === '';

        var optionsSelected = modalOptions.options.filter(function (option) {
          return option.id === _this2.infraction.category || option.id === _this2.infraction.violation;
        });

        modalOptions.error = error;
        modalOptions.disableNext = noComments || optionsSelected.length < 1;

        this.modalContent = {
          header: template(infractionFormHeaderTemplate)(modalOptions),
          body: template(infractionFormBodyTemplate)(modalOptions),
          footer: template(infractionFormFooterTemplate)(modalOptions) };
      }
    }

    /**
       * Shows a generic error to the user.
       * This already sets the template and switches the content.
       */

  }, {
    key: 'showError',
    value: function showError() {
      this.state = 'getInfractionComments';
      this.switchModalContent(true);
    }

    /**
       * Submits the infractions form to GAF.
       */

  }, {
    key: 'submitInfraction',
    value: function submitInfraction() {
      var _this3 = this;

      this.trackSubmit();

      // show loading icon
      document.querySelector('.InfractionsModal-next').classList.add('processing');

      var context = this.options.context || 'profile';

      var data = new FormData();
      data.append('url', window.location.href);
      data.append('objid', this.sourceId);
      data.append('objtype', context);
      data.append('reason', 'other');
      data.append('comments', this.infraction.comments);
      data.append('infraction_type_id', parseInt(this.infraction.violation, 10));

      var headers = new Headers({
        'X-XSRF-TOKEN': getCSRFToken() });

      fetch('/ajax/violation/new.php', {
        headers: headers,
        method: 'POST',
        body: data,
        credentials: 'same-origin' }).then(function (response) {
        if (response.ok) {
          _this3.state = 'infractionSubmitted';
          _this3.switchModalContent();
        } else {
          _this3.showError();
        }
      }).catch(function () {
        _this3.showError();
      });
    }

    /**
       * Event listeners for radio buttons.
       */

  }, {
    key: 'bindOptionEvent',
    value: function bindOptionEvent() {
      var nextButton = document.querySelector('.InfractionsModal-next');
      var options = document.querySelectorAll('.InfractionsModal-option');

      Array.prototype.forEach.call(options, function (option) {
        option.addEventListener('click', function () {
          nextButton.disabled = false;
        });
      });
    }

    /**
       * Event listeners for the category step.
       */

  }, {
    key: 'bindGetInfractionCategoryModalEvents',
    value: function bindGetInfractionCategoryModalEvents() {
      var _this4 = this;

      this.bindOptionEvent();

      // setup get infraction type modal based on chosen violation
      var nextButton = document.querySelector('.InfractionsModal-next');
      nextButton.addEventListener('click', function () {
        var selectedOption = document.querySelector('.InfractionsModal-options > input[type="radio"]:checked').value;

        var choseOtherViolation = selectedOption == _this4.infractionTypesIdLookUp.OTHER;

        if (choseOtherViolation) {
          _this4.infraction.violation = selectedOption;
        } else {
          _this4.infraction.violation = 0;
          _this4.infraction.category = selectedOption;
        }

        _this4.trackModalNextStep();
        _this4.changeModalContentBasedOnInfractionCategory();
        _this4.modalOptions.getComments.error = false;

        _this4.state = choseOtherViolation ? 'getInfractionComments' : 'getInfractionType';
        _this4.switchModalContent();
      });
    }

    /**
       * Event listeners for infraction type step.
       */

  }, {
    key: 'bindGetInfractionTypeModalEvents',
    value: function bindGetInfractionTypeModalEvents() {
      var _this5 = this;

      this.bindOptionEvent();

      // set submission modal content
      var nextButton = document.querySelector('.InfractionsModal-next');
      nextButton.addEventListener('click', function () {
        _this5.infraction.violation = document.querySelector('.InfractionsModal-options > input[type="radio"]:checked').value;
        _this5.changeModalContentBasedOnInfractionType();

        _this5.trackModalNextStep();
        _this5.modalOptions.getComments.error = false;

        // if there was an issue with a project, send them to disputes page
        // otherwise, go to comments modal
        _this5.state = _this5.infraction.violation == _this5.infractionTypesIdLookUp.PROJECT_ISSUE_WITH_USER ? 'infractionSubmitted' : 'getInfractionComments';

        _this5.switchModalContent();
      });

      if (!this.options.defaultInfractionCategory) {
        // go back to infraction modal
        var backButton = document.querySelector('.InfractionsModal-back');
        backButton.addEventListener('click', function () {
          _this5.state = 'getInfractionCategory';
          _this5.switchModalContent();
        });
      }
    }

    /**
       * Event listeners for infraction comments step.
       */

  }, {
    key: 'bindGetInfractionCommentsModalEvents',
    value: function bindGetInfractionCommentsModalEvents() {
      var _this6 = this;

      // enable next button if comments exists
      var nextButton = document.querySelector('.InfractionsModal-next');
      var commentsNode = document.querySelector('.InfractionsModal-comments');

      if (this.options.isCommentOptional) {
        nextButton.disabled = false;
      } else {
        commentsNode.addEventListener('input', function () {
          var hasComments = commentsNode.value === '';
          nextButton.disabled = hasComments;
        });
      }

      nextButton.addEventListener('click', function () {
        _this6.infraction.comments = commentsNode.value;

        if (!_this6.options.isCommentOptional && _this6.infraction.comments.trim().length === 0) {
          _this6.showError();
          return false;
        }

        _this6.submitInfraction();
      });

      // go back to previous modal
      var backButton = document.querySelector('.InfractionsModal-back');
      backButton.addEventListener('click', function () {
        _this6.state = _this6.infraction.violation == _this6.infractionTypesIdLookUp.OTHER && !_this6.options.defaultInfractionCategory ? 'getInfractionCategory' : 'getInfractionType';

        _this6.switchModalContent();
      });
    }

    /**
       * Tracks when the modal was opened.
       */

  }, {
    key: 'trackModalOpen',
    value: function trackModalOpen() {
      window._t.push(['user_action', {
        section: 'InfractionModal',
        label: 'ShowModal',
        reference: this.contextName,
        reference_id: this.sourceId,
        session_id: this.session.id,
        user_id: getUserIdfromCookie() }]);
    }

    /**
       * Tracks when we move to the next step.
       */

  }, {
    key: 'trackModalNextStep',
    value: function trackModalNextStep() {
      window._t.push(['user_action', {
        section: 'InfractionModal',
        subsection: this.state,
        label: 'Continue',
        reference: this.contextName,
        reference_id: this.sourceId,
        session_id: this.session.id,
        user_id: getUserIdfromCookie(),
        name: 'infraction_type_id',
        value: this.infraction.violation }]);
    }

    /**
       * Tracks when we submit the form.
       */

  }, {
    key: 'trackSubmit',
    value: function trackSubmit() {
      window._t.push(['user_action', {
        section: 'InfractionModal',
        subsection: this.state,
        label: 'Submit',
        reference: this.contextName,
        reference_id: this.sourceId,
        session_id: this.session.id,
        user_id: getUserIdfromCookie(),
        name: 'input',
        value: this.infraction.comments }]);
    }
  }]);

  return InfractionsModal;
}();

var errorModalTemplate = "<div id=\"contest-error-modal\" class=\"modal above-quickview hide\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <h3><%- T_(\"오류\") %></h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"alert alert-error\">\n      <p><%=  message  %></p>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"종료\") %></button>\n  </div>\n</div>\n";

var successModalTemplate = "<div id=\"contest-success-modal\" class=\"modal above-quickview hide\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <h3><%- T_(\"완료\") %></h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"alert alert-success\">\n      <p><%=  message  %></p>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"종료\") %></button>\n  </div>\n</div>\n";

var infoModalTemplate = "<div id=\"contest-info-modal\" class=\"modal hide\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <h3>\n      <%-  title  %>\n    </h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"alert alert-info\">\n      <div id=\"messageContainer\"><%=  message  %></div>\n      <div id=\"modalLoader\" class=\"Loader Loader--small Loader--full is-hidden\"></div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"종료\") %></button>\n  </div>\n</div>\n";

var limitReachedModalTemplate = "<div id=\"contest-error-modal\" class=\"modal above-quickview hide\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <h3><%- T_(\"이 콘테스트에 제출할 수 있는 최대 횟수에 도달했습니다.\") %></h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"alert alert-error\">\n      <p>\n        <%= T_(\"무제한 콘테스트 참가를 원하신다면 <a href='/membership'>멤버십으로 계정을 업그레이드</a>해 보세요.\") %>\n      </p>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"종료\") %></button>\n  </div>\n</div>\n";

var defaultOptions$1 = {
  container: document.getElementById('contest_popup-container'),
  message: '',
  template: ''
};

var compiledErrorModalTemplate = template(errorModalTemplate);
var compiledSuccessModalTemplate = template(successModalTemplate);
var compiledInfoModalTemplate = template(infoModalTemplate);
var compiledLimitReachedModalTemplate = template(limitReachedModalTemplate);

var AlertModal = function () {
  function AlertModal(options) {
    var _this = this;

    _classCallCheck(this, AlertModal);

    this.options = Object.assign({}, defaultOptions$1, options);

    this.modal = jq(this.options.template({
      T_: translate,
      message: this.options.message,
      title: this.options.title
    }));

    this.options.container.appendChild(this.modal.get(0));

    this.modal.on('hidden.bs.modal', function () {
      _this.modal.remove();
      _this.options.onHideCallback();
    });
  }

  _createClass(AlertModal, [{
    key: 'show',
    value: function show() {
      this.modal.modal('show');
      return this;
    }

    /**
     * Returns the bootstrap modal
     * @returns {AlertModal.modal|*}
     */

  }, {
    key: 'getModal',
    value: function getModal() {
      return this.modal;
    }
  }]);

  return AlertModal;
}();

function createModal(message, compiledTemplate, container, onHideCallback, title) {
  var params = {
    message: message,
    template: compiledTemplate,
    title: title
  };

  if (container) {
    params.container = container;
  }

  params.onHideCallback = jq.noop;
  if (onHideCallback) {
    params.onHideCallback = onHideCallback;
  }

  return new AlertModal(params);
}

function showErrorModal(message, container) {
  return createModal(message, compiledErrorModalTemplate, container).show();
}

var contestMessageModalTemplate = "<div id=\"contest-message-delete\" class=\"modal hide contest-message-popup above-quickview in\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n    <h3><%- T_(\"메시지 삭제\") %></h3>\n  </div>\n  <div class=\"modal-body\">\n    <p>\n      <strong>\n        <%- T_(\"이 메시지를 삭제하시겠습니까?\") %>\n      </strong>\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"modal-loading hide\" >\n      <img src=\"<%=  cdn_url('/img/dashboard-pending.gif')  %>\">\n    </div>\n    <div class=\"error-msg\"></div>\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"취소\") %></button>\n    <button class=\"btn btn-info confirm-message-delete\"\n      data-selector=\"delete\"\n      data-target=\"confirm-delete\"\n      data-msg-id=\"<%-  msgId  %>\"\n      data-hash=\"<%-  hash  %>\"\n    >\n    <%- T_(\"삭제\") %>\n  </button>\n</div>\n</div>\n\n<div id=\"contest-message-delete-thread\" class=\"modal hide contest-message-popup above-quickview in\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n    <h3><%- T_(\"삭제 - 메시지 타래\") %></h3>\n  </div>\n  <div class=\"modal-body\">\n    <p>\n      <strong>\n        <%- T_(\"이 메시지와 이와 관련한 모든 응답 메시지를 삭제하시겠습니까?\") %>\n      </strong>\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"modal-loading hide\" >\n      <img src=\"<%=  cdn_url('/img/dashboard-pending.gif')  %>\">\n    </div>\n    <div class=\"error-msg\"></div>\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"취소\") %></button>\n    <button class=\"btn btn-info confirm-message-thread-delete\"\n      data-selector=\"delete\"\n      data-target=\"confirm-delete\"\n      data-msg-id=\"<%-  msgId  %>\"\n      data-hash=\"<%-  hash  %>\"\n    >\n    <%- T_(\"삭제\") %>\n  </button>\n</div>\n</div>\n";

var TYPE$1 = {
  MESSAGE_DELETE_MODAL: 'delete-thread',
  REPLY_DELETE_MODAL: 'delete-reply'
};

var compiledMessageModalTemplate = template(contestMessageModalTemplate);

var ContestMessageModal = function () {
  function ContestMessageModal(options) {
    _classCallCheck(this, ContestMessageModal);

    this.modal = null;

    this.options = {
      container: null,
      onDeleteMessage: function onDeleteMessage() {}
    };

    this.options = Object.assign({}, this.options, options);

    this.selectors = {
      modalDeleteThread: '#contest-message-delete-thread',
      modalDeleteReply: '#contest-message-delete',
      btnDelete: '[data-selector="delete"]',
      violationReason: '#message-violation-reason'
    };

    this.modalMap = {};
    this.modalMap[TYPE$1.MESSAGE_DELETE_MODAL] = this.selectors.modalDeleteThread;
    this.modalMap[TYPE$1.REPLY_DELETE_MODAL] = this.selectors.modalDeleteReply;
  }

  _createClass(ContestMessageModal, [{
    key: 'show',
    value: function show(messageId, hash, type) {
      this.modal = jq(compiledMessageModalTemplate({
        msgId: messageId,
        hash: hash,
        T_: translate,
        cdn_url: cdn_url
      }));

      this.options.container.html(this.modal);
      bindButtonEvents(this);
      jq(this.modalMap[type]).modal('show');
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.modal.modal('hide');
      this.modal.remove();
    }
  }]);

  return ContestMessageModal;
}();

function bindButtonEvents(modal) {
  modal.options.container.find(modal.selectors.btnDelete).click(modal.options.onDeleteMessage);

  modal.modal.on('hidden.bs.modal', function () {
    return modal.modal.remove();
  });
}

var pcbTriggerTemplate = "<%= T_('<[= tags ]> 태그를 붙여 등록하시면, 상금 인상 및 콘테스트 업그레이드 요청을 콘테스트 주최자에게 하실 수 있습니다.', { 'tags': tags }) %>\n";

var hashtagTriggerTemplate = "<a href=\"#\" class=\"pcb-hashtag-trigger\" data-selector=\"pcb-hashtag-trigger\" data-tag=\"<%-  tagName  %>\">#<%-  tagName  %></a>\n";

var hashtagTemplate = "<a href=\"#\" class=\"pcb-hashtag\" data-selector=\"pcb-hashtag\" data-tag=\"<%-  tag  %>\" data-tag-type=\"<%-  type  %>\"\n  <%  if (value !== null) {  %>\n    data-value=\"<%-  value  %>\"\n  <%  }  %>>\n  #<%-  tag  %>\n</a>\n";

var compiledPcbTriggerTemplate = template(pcbTriggerTemplate);
var compiledHashtagTriggerTemplate = template(hashtagTriggerTemplate);
var compiledHashtagTemplate = template(hashtagTemplate);

var MessageHashtags = function () {
  function MessageHashtags() {
    _classCallCheck(this, MessageHashtags);

    this.enabled = true;
    this.callbacks = {};
    this.container = document.createElement('div');
    this.hashtags = {
      extended: {
        type: 'upgrade',
        value: 'extend',
        label: 'Extended'
      },
      guaranteed: {
        type: 'upgrade',
        value: 'guaranteed',
        label: 'Guaranteed'
      },
      sealed: {
        type: 'upgrade',
        value: 'sealed',
        label: 'Sealed'
      },
      increaseprize: {
        type: 'prize',
        label: 'IncreasePrize'
      }
    };
    this.disabledTags = {}; // set of tags removed from triggers or disabled
    this.options = {
      triggersEnabled: true, // put hashtag triggers
      tagsEnabled: true, // parse hashtags in message but no functionality
      hashtagCountLimit: 1, // max number of hashtags per type in a msg
      selectors: {
        hashtag: '[data-selector="pcb-hashtag"]',
        trigger: '[data-selector="pcb-hashtag-trigger"]'
      }
    };
  }

  _createClass(MessageHashtags, [{
    key: 'init',
    value: function init(options) {
      var _this = this;

      var selectors = Object.assign({}, this.options.selectors, options.selectors);

      this.options = Object.assign({}, this.options, options);
      this.options.selectors = selectors;

      if (typeof options.enabled !== 'undefined') {
        this.enabled = !!options.enabled;
      }

      if (!this.enabled) {
        return;
      }

      if (options.disabledTags) {
        var disabledTagsKeys = Object.keys(options.disabledTags);
        if (disabledTagsKeys.length) {
          disabledTagsKeys.forEach(function (tag) {
            _this.disableTag(tag);
          });
        }
      }
    }
  }, {
    key: 'transformTags',
    value: function transformTags(message, transformCallback) {
      var _this2 = this;

      if (!this.enabled) {
        return message;
      }

      var regex = /#([a-z]+)/g;
      var hashtagCounts = {};

      return message.replace(regex, function (match, hash) {
        if (hash in _this2.hashtags) {
          if (!_this2.options.tagsEnabled || hash in _this2.disabledTags) {
            var tag = document.createElement('strong');
            tag.innerHTML = match;
            return tag.outerHTML;
          }

          if (!hashtagCounts[hash]) {
            hashtagCounts[hash] = 0;
          }

          if (hashtagCounts[hash] < _this2.options.hashtagCountLimit) {
            var tagValue = _this2.hashtags[hash];
            hashtagCounts[hash]++;
            if (transformCallback) {
              transformCallback(tagValue);
            }

            return compiledHashtagTemplate({
              type: tagValue.type,
              tag: hash,
              value: tagValue.value
            });
          }
        }

        return match;
      });
    }
  }, {
    key: 'addTriggers',
    value: function addTriggers(container) {
      var _this3 = this;

      if (!this.enabled || !this.options.triggersEnabled) {
        return;
      }

      var hashtagLinks = Object.keys(this.hashtags).filter(function (tagName) {
        return !(tagName in _this3.disabledTags);
      }).map(function (tagName) {
        return compiledHashtagTriggerTemplate({ tagName: tagName }).trim();
      });

      if (hashtagLinks.length) {
        container.html(compiledPcbTriggerTemplate({
          tags: hashtagLinks.join(', '),
          T_: translate
        }));

        this.attachTriggerEventHandlers(container);
      }
    }
  }, {
    key: 'attachTagEventHandlers',
    value: function attachTagEventHandlers(container) {
      var _this4 = this;

      container.on('click', this.options.selectors.hashtag, function (event) {
        event.preventDefault();
        var hashtag = event.target;
        var tag = hashtag.getAttribute('data-tag');
        var tagData = _this4.getTag(tag);
        if (tagData) {
          tagData.el = hashtag;
          _this4.trigger('hashtagClicked', tagData);
        }
      });
    }
  }, {
    key: 'attachTriggerEventHandlers',
    value: function attachTriggerEventHandlers(container) {
      var _this5 = this;

      container.off().on('click', this.options.selectors.trigger, function (event) {
        event.preventDefault();
        var trigger = event.target;
        var tag = trigger.getAttribute('data-tag');
        var tagData = _this5.getTag(tag);
        if (tagData) {
          tagData.el = trigger;
          _this5.trigger('triggerClicked', tagData);
        }
      });
    }
  }, {
    key: 'getTag',
    value: function getTag(tag) {
      if (tag in this.hashtags) {
        var tagValue = this.hashtags[tag];
        return {
          tag: tag,
          type: tagValue.type,
          value: tagValue.value
        };
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(event, data) {
      if (this.callbacks[event] && this.callbacks[event].length) {
        this.callbacks[event].forEach(function (callbackEventFunc) {
          callbackEventFunc(data);
        });
      }
    }
  }, {
    key: 'disableTag',
    value: function disableTag(tag) {
      if (tag in this.hashtags) {
        this.disabledTags[tag] = true;
      }
    }
  }, {
    key: 'on',
    value: function on(event, callback) {
      if (!this.callbacks[event]) {
        this.callbacks[event] = [];
      }
      this.callbacks[event].push(callback);
    }
  }]);

  return MessageHashtags;
}();

var contestMessageTemplate = "<li class=\"commentBoard-comment\" data-selector=\"comment-main\">\n  <img src=\"<%-  profile_logo_url  %>\" class=\"commentBoard-avatar\" alt=\"<%- T_('프로필 이미지') %>\" />\n  <header class=\"commentBoard-headerItems\">\n    <%  if (is_holder_message) {  %>\n      <span class=\"commentBoard-userType\"><%- T_('콘테스트 주최자') %></span>\n    <%  } else if (isUserMessage){  %>\n      <h6 class=\"commentBoard-commentHeader\">\n        <%-  publicUserName  %>\n      </h6>\n    <%  } else {  %>\n      <h6 class=\"commentBoard-commentHeader\">\n        <a href=\"/u/<%-  username  %>\" data-selector=\"comment-username\"><%-  publicUserName  %></a>\n      </h6>\n    <%  }  %>\n    <ul class=\"commentBoard-commentDetails\" data-selector=\"comment-details\"></ul>\n  </header>\n  <p data-selector=\"comment-formatted-message\"><%=  formattedComment  %></p>\n  <%  if (!parentId) {  %>\n    <%  if (numHidden > 0) {  %>\n      <div class=\"view-more-comment\">\n        <a href=\"javascript:void(0)\" class=\"small\" data-selector=\"view-more-comment-link\">\n          <%  if(numHidden !== 1){ %>\n            <%- T_('메시지 <[- numHidden ]>건 더 확인', { numHidden: numHidden }) %>\n          <%  } else {  %>\n            <%- T_('메시지 한 건 더 확인') %>\n          <%  }  %>\n        </a>\n        <img src=\"<%-  cdn_url('/img/ajax-loader.gif')  %>\"\n          class=\"view-more-comment-loader hide\"\n          data-selector=\"view-more-comment-loader\"\n          alt=\"<%- T_('처리중...') %>\"/>\n      </div>\n    <%  }  %>\n    <ol class=\"commentBoard-subList contest-replies\" data-selector=\"comment-reply-list\"></ol>\n  <%  }  %>\n  <ul class=\"commentBoard-commentDetails commentBoard-mobile\" data-selector=\"comment-details\"></ul>\n  <%  if (!parentId) {  %>\n    <div class=\"Comment Comment--commentBoard is-hidden\" data-selector=\"comment-reply\">\n      <figure class=\"Comment-profile\">\n        <img src=\"<%-  profilePic  %>\" width=\"56\" height=\"56\"\n          alt=\"<%- T_('프로필 이미지') %>\" class=\"Comment-profileImage\" />\n      </figure>\n      <form class=\"Comment-form\" data-selector=\"comment-form\" data-load=\"loading/loading-overlay\">\n        <textarea placeholder=\"<%- T_('검토 의견을 작성하여 주십시오.') %>\"\n          class=\"Comment-field\" data-selector=\"comment-reply-input\"\n          rows=\"1\" ></textarea>\n        <div class=\"loading-overlay is-loading pcb-loader is-hidden\" data-selector=\"loading-overlay\"></div>\n        <div class=\"pcb_error alert alert-error hide\" data-selector=\"comment-error\"></div>\n        <div class=\"pcb-hashtag-container\" data-selector=\"pcb-hashtag-container\"></div>\n      </form>\n    </div>\n  <%  }  %>\n</li>\n";

var contestMessageControlsTemplate = "<li data-selector=\"comment-timestamp\"><%-  formattedDate  %></li>\n<%  if (canBeRepliedTo) {  %>\n  <li>\n    <a class=\"commentBoard-reply\" data-selector=\"comment-control-reply\">\n      <%- T_('회신') %>\n    </a>\n  </li>\n<%  }  %>\n<%  if (canBeDeleted) {  %>\n  <li>\n    <a class=\"commentBoard-delete\" data-selector=\"comment-control-delete\">\n      <%- T_('삭제') %>\n    </a>\n  </li>\n<%  }  %>\n<%  if (canBeReported) {  %>\n  <li>\n    <a class=\"commentBoard-report\" data-selector=\"comment-control-report\">\n      <%- T_('문제 제기') %>\n    </a>\n  </li>\n<%  }  %>\n";

var emptyMessageTemplate = "<p id=\"no_msgs\" class=\"no-message\" data-selector=\"empty-message\"><%- T_('아직 메시지가 없습니다.') %></p>\n";

var THREAD_DISPLAY_SIZE = 2;
var KEYCODE_ENTER = 13;
var hideClass = 'is-hidden';
var messageApi = new MessageApi();
var messageHashtags = new MessageHashtags();
var compiledEmptyMessageTemplate = template(emptyMessageTemplate);
var lt = new LocalTracking();

var Message = function () {
  function Message(messageData, messageBoard, isReply, template$$1) {
    var _this = this;

    _classCallCheck(this, Message);

    this.parent = messageBoard;
    this.data = {
      annotationId: null,
      entryId: null,
      fileId: null,
      formattedComment: null,
      formattedDate: null,
      is_holder_message: false,
      is_private_message: false,
      msg_id: null,
      parentId: null,
      privacy: null,
      profile_logo_url: null,
      threadMsgs: [],
      threadSize: 0,
      timestamp: null,
      toUserId: null,
      totalHiddenMessages: 0,
      userId: null,
      user_url: null,
      username: null,
      xCoordinate: null,
      yCoordinate: null };

    this.data = Object.assign({}, this.data, messageData);
    this.isReply = isReply;
    this.reportMessageModal = null;
    this.replies = [];
    this.template = template$$1 || this.getMessageTemplate();
    this.modalContainer = jq('#contest_popup-container');
    this.contestMessageModal = new ContestMessageModal({
      container: this.modalContainer,
      onDeleteMessage: function onDeleteMessage() {
        return _this.onDeleteConfirm();
      } });

    this.bindMessageEvents();
  }

  _createClass(Message, [{
    key: 'getMessageTemplate',
    value: function getMessageTemplate() {
      var options = this.parent.options;
      var rawTemplate = options.messageTemplate || contestMessageTemplate;

      if (!this.isReply) {
        this.data.numHidden = this.data.threadSize - THREAD_DISPLAY_SIZE;
      } else {
        this.data.numHidden = 0;
      }

      this.data.profilePic = options.user.profilePic;
      this.data.isUserMessage = options.user.id === parseInt(this.data.userId, 10);

      if (this.isContestHolderMessage()) {
        this.data.formattedComment = messageHashtags.transformTags(this.data.formattedComment);
      }

      var controlVars = {
        canBeDeleted: options.controls.delete && (options.contest.isContestHolder || this.data.isUserMessage),
        canBeReported: options.controls.report && !this.data.isUserMessage,
        canBeRepliedTo: options.controls.reply && !this.data.parentId,
        formattedDate: this.data.formattedDate,
        T_: translate };

      this.data.T_ = translate;
      this.data.cdn_url = cdn_url;

      var messageTemplate = jq(template(rawTemplate)(this.data));
      var messageControlsTemplate = jq(template(contestMessageControlsTemplate)(controlVars));

      messageTemplate.find(options.selectors.commentDetails).append(messageControlsTemplate);

      return messageTemplate;
    }
  }, {
    key: 'isContestHolderMessage',
    value: function isContestHolderMessage() {
      return !this.data.is_holder_message;
    }
  }, {
    key: 'bindMessageEvents',
    value: function bindMessageEvents() {
      var _this2 = this;

      this.template.find(this.parent.options.selectors.viewMoreCommentLink).click(function (event) {
        return _this2.onViewMoreRepliesClick(event);
      });
      this.template.find(this.parent.options.selectors.commentControlReply).click(function (event) {
        return _this2.onReplyClick(event);
      });
      this.template.find(this.parent.options.selectors.commentControlDelete).click(function (event) {
        return _this2.onDeleteClick(event);
      });
      this.template.find(this.parent.options.selectors.commentControlReport).click(function () {
        return _this2.onReportClick();
      });
      this.template.find(this.parent.options.selectors.textArea).keydown(function (event) {
        return onInputFieldKeydown(_this2, event, true);
      });

      if (this.data.annotationId) {
        this.template.click(function (event) {
          return _this2.onCommentClick(event);
        });
      }

      this.template.find(this.parent.options.selectors.username).click(function () {
        return _this2.onUsernameClick();
      });

      messageHashtags.addTriggers(this.template.find(this.parent.options.selectors.pcbHashtagContainer));

      messageHashtags.attachTagEventHandlers(this.template);
    }
  }, {
    key: 'onUsernameClick',
    value: function onUsernameClick() {
      var subsection = '';

      if (this.data.entryId) {
        subsection = 'EntryQuickViewClarificationBoard';
      } else {
        subsection = 'ContestClarificationBoard';
      }

      lt.push(['user_action', {
        section: 'ContestViewPage',
        subsection: subsection,
        name: 'clickUsername',
        reference: 'contest_id',
        reference_id: this.parent.options.contest.id,
        label: 'user_id',
        value: this.data.userId }]);
    }
  }, {
    key: 'onViewMoreRepliesClick',
    value: function onViewMoreRepliesClick(event) {
      var _this3 = this;

      var currentTarget = jq(event.currentTarget);
      currentTarget.parent().find(this.parent.options.selectors.viewMoreCommentLoader).show();
      currentTarget.hide();

      getMessages(this.parent, {
        parent_id: this.data.msg_id,
        project_id: this.parent.options.contest.id }).then(function (messageData) {
        if (messageData && messageData.messages) {
          (function () {
            var fragment = jq(document.createDocumentFragment());
            messageData.messages.filter(function (threadMsg) {
              return !_this3.replies[threadMsg.msg_id];
            }).forEach(function (threadMsg) {
              var reply = new Message(threadMsg, _this3.parent, true);
              _this3.addReply(fragment, reply, true);
            });

            currentTarget.closest(_this3.parent.options.selectors.comment).find(_this3.parent.options.selectors.replies).prepend(fragment);
            currentTarget.parent().hide();
          })();
        }
      }).catch(function (error) {
        return _this3.parent.options.events.onError(error);
      });
    }
  }, {
    key: 'onReplyClick',
    value: function onReplyClick(event) {
      var replyContainer = jq(event.target).closest(this.parent.options.selectors.comment);

      var replySection = replyContainer.find(this.parent.options.selectors.reply);

      if (replySection.hasClass(hideClass)) {
        replySection.fadeIn('fast');
        replySection.removeClass(hideClass);
        replyContainer.find(this.parent.options.selectors.textArea).focus();
      } else {
        replySection.fadeOut('fast');
        replySection.addClass(hideClass);
      }
    }
  }, {
    key: 'onDeleteClick',
    value: function onDeleteClick(event) {
      var comment = jq(event.target).closest(this.parent.options.selectors.comment);

      var msgId = this.data.msg_id;
      var hash = '';
      var modalType = TYPE$1.REPLY_DELETE_MODAL;

      if (comment.find(this.parent.options.selectors.replies).children().length > 0) {
        modalType = TYPE$1.MESSAGE_DELETE_MODAL;
      }

      this.contestMessageModal.show(msgId, hash, modalType);
    }
  }, {
    key: 'onDeleteConfirm',
    value: function onDeleteConfirm() {
      this.deleteMessage().catch(function () {});
      this.contestMessageModal.hide();
    }
  }, {
    key: 'onReportClick',
    value: function onReportClick() {
      lt.push(['user_action', {
        section: this.parent.options.pageName,
        subsection: 'PublicClarificationBoard',
        name: 'ReportViolation',
        reference: 'contest_message_id',
        reference_id: this.data.msg_id,
        label: 'contest_id',
        value: this.parent.options.contest.id }]);

      if (!this.reportMessageModal) {
        this.reportMessageModal = new InfractionsModal(this.parent.options.infractionTypes, this.data.msg_id, {
          defaultInfractionCategory: 'contestMessage',
          isCommentOptional: true,
          context: 'contest_message' });
      }
      this.reportMessageModal.modal.show();
    }
  }, {
    key: 'onCommentClick',
    value: function onCommentClick(event) {
      if (!this.parent.options.enableAnnotations) {
        return false;
      }

      var eventTarget = jq(event.target);
      if (eventTarget.is('a') || eventTarget.is('textarea')) {
        return false;
      }

      this.parent.options.events.onMessageClicked(event, this);
    }
  }, {
    key: 'moderateMessage',
    value: function moderateMessage(options) {
      var data = {
        project_id: this.parent.options.contest.id,
        msg_id: options.messageId };

      return messageApi.deleteMessage(data);
    }
  }, {
    key: 'addReply',
    value: function addReply(container, reply, prepend) {
      this.replies[reply.data.msg_id] = reply;
      if (prepend) {
        container.prepend(reply.template);
      } else {
        container.append(reply.template);
      }
    }
  }, {
    key: 'updateMessage',
    value: function updateMessage(newMessageText) {
      var _this4 = this;

      var currentMessageText = this.data.formattedComment;
      var inputField = this.template.find(this.parent.options.selectors.textArea).first();
      var errorMessage = void 0;

      inputField.prop('disabled', true);
      inputField.parent().find('.loading-overlay').removeClass(hideClass);
      jq(this.parent.options.selectors.pcbError).hide();

      return new Promise(function (resolve, reject) {
        messageApi.updateMessage({
          message_id: parseInt(_this4.data.msg_id, 10),
          message: newMessageText }).then(function (response) {
          if (response.status !== 'failed') {
            inputField.val('');

            _this4.data.formattedComment = response.message.formattedComment;
            _this4.data.formattedDate = response.message.formattedDate;
            _this4.data.timestamp = response.message.timestamp;

            var firstComment = _this4.parent.options.messageContainer.children().first();
            // The quickview PCB supposedly has two layouts - one for mobile
            // and one for desktop. Each layout has a separate container for
            // the comment details - including the timestamp.
            // We'll update both here.
            var timestampContainers = _this4.template.find(_this4.parent.options.selectors.messageTimestamp);

            var messageTextContainer = _this4.template.find(_this4.parent.options.selectors.formattedMessage).first();

            timestampContainers.html(response.message.formattedDate);
            messageTextContainer.html(response.message.formattedComment);

            if (!_this4.template.is(firstComment)) {
              _this4.template.insertBefore(firstComment).fadeIn('fast');
            }

            onMessageUpdated(_this4.parent, response.message.id, response.message);

            _this4.parent.options.events.onMessageUpdated(response.message.id, response.message);

            resolve(response.message);
          } else {
            if (response.error) {
              errorMessage = response.error;
            }

            if (errorMessage === '') {
              errorMessage = translate('메세지를 전달할 수 없습니다.');
            }

            _this4.parent.options.events.onError(errorMessage);
            reject(errorMessage, currentMessageText);
          }
        }).catch(function () {
          errorMessage = translate('서버 오류입니다. 고객님의 메시지를 전송하지 못했습니다.');
          _this4.parent.options.events.onError(errorMessage);
          reject(errorMessage, currentMessageText);
        }).then(function () {
          inputField.prop('disabled', false);
          inputField.parent().find('.loading-overlay').addClass(hideClass);
        });
      });
    }
  }, {
    key: 'deleteMessage',
    value: function deleteMessage() {
      var _this5 = this;

      var errorMessage = translate('메시지를 삭제할 수 없습니다.');
      var inputField = this.template.find(this.parent.options.selectors.textArea).first();

      inputField.prop('disabled', true);
      inputField.parent().find(this.parent.options.selectors.loadingOverlay).removeClass(hideClass);
      jq(this.parent.options.selectors.pcbError).hide();

      var messageId = this.data.msg_id;

      return new Promise(function (resolve, reject) {
        _this5.moderateMessage({
          messageId: messageId,
          action: 'delete' }).then(function (response) {
          if (response && response.success) {
            _this5.template.remove();
            onMessageDeleted(_this5.parent, messageId);
            _this5.parent.options.events.onMessageDeleted(messageId);
            return resolve();
          }

          if (response && response.errors) {
            errorMessage = response.errors.reduce(function (initial, value) {
              return initial + '\n' + value + '. ';
            }, errorMessage);
          }

          throw errorMessage;
        }).catch(function (errorMessage) {
          _this5.parent.options.events.onError(errorMessage);
          reject(errorMessage);
        }).then(function () {
          inputField.prop('disabled', false);
          inputField.parent().find('.loading-overlay').addClass(hideClass);
        });
      });
    }
  }]);

  return Message;
}();

var MessageBoard = function () {
  function MessageBoard(options, privacy) {
    var _this6 = this;

    _classCallCheck(this, MessageBoard);

    this.messages = [];
    this.options = {
      contest: {
        id: null,
        contestHolderId: null,
        isContestHolder: false,
        upgrades: null },

      entry: {
        id: 0 },

      user: {
        id: null,
        hasEntries: false,
        profilePic: '' },

      toUser: {
        id: null },

      limit: 50,
      events: {
        onHashtagClick: function onHashtagClick() {},
        onMessagesLoaded: function onMessagesLoaded() {},
        onMessagePostingStart: function onMessagePostingStart() {},
        onMessagePostingEnd: function onMessagePostingEnd() {},
        onMessagePosted: function onMessagePosted() {},
        onMessageUpdated: function onMessageUpdated() {},
        onMessageDeleted: function onMessageDeleted() {},
        onMessageClicked: function onMessageClicked() {},
        onError: showErrorModal },

      preload: {
        enabled: false,
        messagesData: {},
        prerendered: true },

      controls: {
        delete: true,
        reply: true,
        report: true },

      messageHashtags: {
        enabled: false,
        triggersEnabled: false },

      infractionTypes: [],
      enableAnnotations: false,
      messageTemplate: null,
      messageContainer: jq('#MessagesContainer'),
      messageBoardContainer: jq('#MessageBoard'),
      selectors: {
        showMore: '#messages_show_more',
        reply: '[data-selector="comment-reply"]',
        comment: '[data-selector="comment-main"]',
        commentControlReply: '[data-selector="comment-control-reply"]',
        commentControlDelete: '[data-selector="comment-control-delete"]',
        commentControlReport: '[data-selector="comment-control-report"]',
        commentDetails: '[data-selector="comment-details"]',
        commentForm: '[data-selector="comment-form"]',
        textArea: '[data-selector="comment-reply-input"]',
        mainTextArea: '[data-selector="comment-main-input"]',
        viewMoreCommentLink: '[data-selector="view-more-comment-link"]',
        viewMoreCommentLoader: '[data-selector="view-more-comment-loader"]',
        pcbError: '[data-selector="comment-error"]',
        pcbHashtagContainer: '[data-selector="pcb-hashtag-container"]',
        pcbShowComments: '[data-selector="pcb-show-comments"]',
        replies: '[data-selector="comment-reply-list"]',
        loadingOverlay: '[data-selector="loading-overlay"]',
        messageTimestamp: '[data-selector="comment-timestamp"]',
        formattedMessage: '[data-selector="comment-formatted-message"]',
        emptyMessage: '[data-selector="empty-message"]',
        username: '[data-selector="comment-username"]' },

      showEmptyMessage: false,
      pageName: null };

    this.messageStart = 0;
    this.privacy = privacy;

    this.showMoreMessagesContainer = jq(this.options.selectors.showMore);

    var optionsEvents = Object.assign({}, this.options.events, options.events);

    var optionsSelectors = Object.assign({}, this.options.selectors, options.selectors);

    this.options = Object.assign({}, this.options, options);
    this.options.events = optionsEvents;
    this.options.selectors = optionsSelectors;

    this.initializeHashTags();
    this.populateMessageBoard(false, true).then(function () {
      return _this6.bindMessageBoardEvents();
    }).catch(function (error) {
      return _this6.options.events.onError(error);
    });
  }

  _createClass(MessageBoard, [{
    key: 'populateMessageBoard',
    value: function populateMessageBoard(loader, useCache) {
      var _this7 = this;

      var data = {
        start: this.messageStart,
        limit: this.options.limit };

      return getMessages(this, data, useCache).then(function (response) {
        _this7.loadMessages(response.messages);
        _this7.renderMessages();
        _this7.options.events.onMessagesLoaded(response);
        return response;
      }).then(function (response) {
        _this7.options.messageBoardContainer.removeClass(hideClass);
        _this7.showMoreMessagesContainer.find('a').show();

        if (response.total_messages > _this7.messageStart) {
          _this7.showMoreMessagesContainer.removeClass(hideClass);
        } else {
          _this7.showMoreMessagesContainer.addClass(hideClass);
        }

        if (loader) {
          loader.hide();
        }
      }).catch(function (error) {
        return _this7.options.events.onError(error);
      }).then(function () {
        if (_this7.options.preload.prerendered) {
          _this7.options.preload.prerendered = false;
        }
      });
    }
  }, {
    key: 'loadMessages',
    value: function loadMessages(messages) {
      var _this8 = this;

      if (!messages || messages.length === 0) {
        return;
      }

      messages.forEach(function (rootMessage) {
        var messageTemplate = _this8.options.preload.enabled && _this8.options.preload.prerendered ? _this8.options.messageContainer.find('[data-message-id=' + rootMessage.msg_id + ']') : null;

        var message = new Message(rootMessage, _this8, false, messageTemplate);

        if (Array.isArray(rootMessage.threadMsgs)) {
          rootMessage.threadMsgs.forEach(function (threadMessage) {
            var replyTemplate = _this8.options.preload.enabled && _this8.options.preload.prerendered ? _this8.options.messageContainer.find('[data-message-id=' + threadMessage.msg_id + ']') : null;

            var reply = new Message(threadMessage, _this8, true, replyTemplate);

            message.addReply(message.template.find(_this8.options.selectors.replies), reply);

            _this8.messageStart++;
          });
        }

        _this8.messageStart++;
        _this8.messages.push(message);
      });
    }
  }, {
    key: 'renderMessages',
    value: function renderMessages() {
      if (this.options.preload.enabled && this.options.preload.prerendered) {
        return;
      }

      if (this.options.showEmptyMessage) {
        var emptyMessage = jq(this.options.selectors.emptyMessage);

        if (!emptyMessage.length) {
          emptyMessage = jq(compiledEmptyMessageTemplate({
            T_: translate }));

          this.options.messageContainer.parent().append(emptyMessage);
        }

        if (this.messages.length) {
          emptyMessage.addClass(hideClass);
        } else {
          emptyMessage.removeClass(hideClass);
        }
      }

      var fragment = jq(document.createDocumentFragment());
      this.messages.forEach(function (message) {
        fragment.append(message.template);
      });

      this.options.messageContainer.append(fragment);
    }
  }, {
    key: 'bindMessageBoardEvents',
    value: function bindMessageBoardEvents() {
      var _this9 = this;

      jq(this.options.selectors.mainTextArea).off('keydown').keydown(function (event) {
        return onInputFieldKeydown(_this9, event, false);
      });

      this.options.messageBoardContainer.find(this.options.selectors.showMore).off('click').click(function (event) {
        return _this9.onShowMoreClick(event);
      });
    }
  }, {
    key: 'initializeHashTags',
    value: function initializeHashTags() {
      var _this10 = this;

      messageHashtags.init({
        enabled: this.options.messageHashtags.enabled,
        triggersEnabled: this.options.messageHashtags.triggersEnabled });

      if (this.options.contest.upgrades) {
        var upgradesKeys = Object.keys(this.options.contest.upgrades);
        if (upgradesKeys.length) {
          upgradesKeys.forEach(function (upgradeName) {
            if (_this10.options.contest.upgrades[upgradeName]) {
              messageHashtags.disableTag(upgradeName);
            }
          });
        }
      }

      messageHashtags.addTriggers(this.options.messageBoardContainer.find(this.options.selectors.pcbHashtagContainer));

      messageHashtags.on('triggerClicked', function (data) {
        var commentArea = jq(data.el).closest(_this10.options.selectors.commentForm).find('textarea');
        if (commentArea.length) {
          commentArea.val(commentArea.val() + ' #' + data.tag);
        }
      });

      messageHashtags.on('hashtagClicked', function (data) {
        _this10.options.events.onHashtagClick(data);
      });
    }
  }, {
    key: 'onShowMoreClick',
    value: function onShowMoreClick(event) {
      var target = jq(event.target).closest(this.options.selectors.pcbShowComments);

      var loader = target.find(this.options.selectors.viewMoreCommentLoader);
      loader.show();
      target.find('a').hide();
      this.populateMessageBoard(loader, false);
    }
  }, {
    key: 'postMessage',
    value: function postMessage(messageText, fileId, xCoordinate, yCoordinate) {
      var inputField = jq(this.options.selectors.mainTextArea);
      var messageData = {
        text: messageText,
        fileId: fileId,
        coordinates: {
          x: xCoordinate,
          y: yCoordinate } };

      return submitMessage(this, inputField, false, messageData).catch(function () {});
    }
  }, {
    key: 'findMessageByAnnotationId',
    value: function findMessageByAnnotationId(annotationId) {
      var messageObject = this.messages.find(function (message) {
        return parseInt(message.data.annotationId, 10) === parseInt(annotationId, 10);
      });

      return messageObject;
    }
  }, {
    key: 'updateMessageByAnnotationId',
    value: function updateMessageByAnnotationId(annotationId, newMessageText) {
      var messageObject = this.findMessageByAnnotationId(annotationId);

      if (!messageObject) {
        return Promise.reject(translate('업데이트할 메시지를 찾지 못했습니다.'));
      }

      return messageObject.updateMessage(newMessageText);
    }
  }, {
    key: 'deleteMessageByAnnotationId',
    value: function deleteMessageByAnnotationId(annotationId) {
      var messageObject = this.findMessageByAnnotationId(annotationId);

      if (!messageObject) {
        return Promise.reject(translate('삭제할 메시지를 찾지 못했습니다.'));
      }

      return messageObject.deleteMessage().catch(function () {});
    }
  }, {
    key: 'showAnnotationMarkers',
    value: function showAnnotationMarkers() {
      this.options.enableAnnotations = true;
      jq('.annotation-marker').removeClass('is-hidden');
    }
  }, {
    key: 'hideAnnotationMarkers',
    value: function hideAnnotationMarkers() {
      this.options.enableAnnotations = false;
      jq('.annotation-marker').addClass('is-hidden');
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.messages = [];
      this.messageStart = 0;

      this.options.messageContainer.empty();
    }
  }, {
    key: 'setEntryId',
    value: function setEntryId(entryId) {
      this.options.entry.id = entryId;
    }
  }, {
    key: 'disablePreload',
    value: function disablePreload() {
      this.options.preload.enabled = false;
    }
  }]);

  return MessageBoard;
}();

function onInputFieldKeydown(context, event, fromReply) {
  if (event.keyCode !== KEYCODE_ENTER || event.shiftKey) {
    return;
  }

  submitMessage(context, jq(event.target), fromReply).catch(function () {});
}

function submitMessage(context, input, fromReply, annotationData) {
  var errorMessage = translate('메세지를 전달할 수 없습니다.');

  var messageData = Object.assign({}, {
    text: input.val(),
    parentId: fromReply ? context.data.msg_id : null }, annotationData);

  var board = fromReply ? context.parent : context;

  input.prop('disabled', true);
  input.parent().find(board.options.selectors.loadingOverlay).removeClass(hideClass);

  jq(board.options.selectors.pcbError).hide();

  return new Promise(function (resolve, reject) {
    postMessage(board, messageData).then(function (response) {
      if (response.success) {
        input.val('');

        var message = new Message(response.message, board, fromReply);

        if (fromReply) {
          message.template.hide();
          context.addReply(input.closest(board.options.selectors.comment).find(board.options.selectors.replies), message);

          input.closest(board.options.selectors.reply).addClass(hideClass);
        } else {
          message.template.hide().prependTo(board.options.messageContainer);
        }

        message.template.fadeIn('slow');

        board.messageStart++;
        board.messages.unshift(message);
        board.options.events.onMessagePosted(response.message);
        resolve(response.message);
      } else {
        if (Array.isArray(response.errors)) {
          errorMessage = response.errors.reduce(function (initial, value) {
            return initial + '\n' + value + '.';
          }, errorMessage);
        }

        if (response.errors && Array.isArray(response.errors.comment) && response.errors.comment.length) {
          errorMessage = response.errors.comment[0];
        }

        throw errorMessage;
      }
    }).catch(function (message) {
      board.options.events.onError(message);
      reject(message);
    }).then(function () {
      input.prop('disabled', false);
      input.parent().find(board.options.selectors.loadingOverlay).addClass(hideClass);
      board.options.events.onMessagePostingEnd();
    });
  });
}

function postMessage(board, messageData) {
  var data = {
    privacy: board.privacy,
    project_id: board.options.contest.id,
    comment: messageData.text };

  if (messageData.parentId) {
    data.parent_id = messageData.parentId;
  }

  if (board.options.entry.id) {
    data.entry_id = board.options.entry.id;
    data.to_user_id = board.options.toUser.id;

    if (board.options.entry.number) {
      data.entry_number = board.options.entry.number;
    }

    if (messageData.coordinates) {
      if (messageData.coordinates.x) {
        data.x_coordinate = messageData.coordinates.x;
      }

      if (messageData.coordinates.y) {
        data.y_coordinate = messageData.coordinates.y;
      }
    }

    if (messageData.fileId) {
      data.file_id = messageData.fileId;
    }
  }

  return messageApi.postMessage(data);
}

function getMessages(board, customParams, useCache) {
  return new Promise(function (resolve, reject) {
    if (useCache && board.options.preload.enabled) {
      return resolve(board.options.preload.messagesData);
    }

    var data = {
      project_id: board.options.contest.id };

    if (board.options.entry.id) {
      data.entry_id = board.options.entry.id;
    }

    var params = Object.assign({}, data, customParams);
    messageApi.getMessages(params).then(function (response) {
      return resolve(response);
    }).catch(function () {
      return reject(translate('메시지를 가져오지 못했습니다.'));
    });
  });
}

function onMessageDeleted(board, messageId) {
  var index = board.messages.findIndex(function (message) {
    return parseInt(message.data.msg_id, 10) === parseInt(messageId, 10);
  });

  if (index !== -1) {
    board.messages.splice(index, 1);
    board.messageStart--;
  }
}

function onMessageUpdated(board, messageId, messageJSON) {
  var index = board.messages.findIndex(function (message) {
    return parseInt(message.data.msg_id, 10) === parseInt(messageId, 10);
  });

  if (index !== -1) {
    var message = board.messages[index];
    message.data.formattedComment = messageJSON.formattedComment;
    message.data.formattedDate = messageJSON.formattedDate;
    message.data.timestamp = messageJSON.timestamp;
    board.messages.splice(index, 1);
    board.messages.unshift(message);
  }
}

var contestsInterestedInTemplate = "<div class=\"span4 contest-related-wrapper dataList FeatureFlag-search\">\n  <div class=\"contest-related-items dataList-set\">\n    <h5 class=\"contest-related-items-title dataList-header\"><%= T_('유사한 콘테스트') %></h5>\n    <div class=\"dataList-items\">\n      <%  contestsInterestedIn.forEach(function(contest) {  %>\n        <div class=\"contest-related-item dataList-item\">\n          <span class=\"contest-related-item-title dataList-authorLink\">\n            <a href=\"<%-  contest.seoUrl  %>\">\n              <%-  contest.project_name  %>\n            </a>\n          </span>\n          <span class=\"contest-related-item-author dataList-itemAuthor\">\n            <%  if (loggedIn) {  %>\n              <a href=\"<%-  contest.user_info.url  %>\">\n                <%= T_('- 주최자: <[- uname ]>님', { uname: contest.user_info.publicName }) %>\n              </a>\n            <%  } else {  %>\n              <span>\n                <%= T_('- 주최자: <[- uname ]>님', { uname: contest.user_info.publicName }) %>\n              </span>\n            <%  }  %>\n          </span>\n          <span class=\"contest-related-item-value dataList-itemPrice\">\n            $<%-  contest.bid_avg_usd  %> USD\n          </span>\n        </div>\n      <%  });  %>\n      <a class=\"contest-related-more dataList-link\" href=\"/jobs/j-contest-t-featured/\">\n        <%= T_('추가 확인') %>\n      </a>\n    </div>\n  </div>\n  <div class=\"contest-related-items dataList-set\">\n    <h5 class=\"contest-related-items-title dataList-header\"><%= T_('콘테스트 완료 목록') %></h5>\n    <div class=\"dataList-items\">\n      <%  completedContests.forEach(function(contest) {  %>\n        <div class=\"contest-related-item dataList-item\">\n          <span class=\"contest-related-item-title dataList-authorLink\">\n            <a href=\"<%-  contest.contestURL  %>\">\n              <%-  contest.contest_name  %>\n            </a>\n          </span>\n          <span class=\"contest-related-item-author dataList-itemAuthor\">\n            <%  if (loggedIn) {  %>\n              <a href=\"/u/<%-  contest.username  %>\">\n                <%= T_('- 주최자: <[- uname ]>님', { uname: contest.publicUserName }) %>\n              </a>\n            <%  } else {  %>\n              <span>\n                <%= T_('- 주최자: <[- uname ]>님', { uname: contest.publicUserName }) %>\n              </span>\n            <%  }  %>\n          </span>\n          <span class=\"contest-related-item-value dataList-itemPrice\">\n            $<%-  contest.prizeInUSD  %> USD\n          </span>\n        </div>\n      <%  });  %>\n    </div>\n  </div>\n</div>\n";

var templateInterestedIn = template(contestsInterestedInTemplate);
var contestApi = new ContestApi();

function init() {
  var container = document.getElementById('contestViewContainer');
  var projectId = container.getAttribute('data-contest-id');
  getContestsInterestedIn(projectId).then(function (data) {
    data.T_ = translate;
    var target = document.getElementById('contests-related-container');
    target.innerHTML += templateInterestedIn(data);
  });
}

function getContestsInterestedIn(projectId) {
  return contestApi.getContestsInterestedIn({
    project_id: projectId
  }).then(function (response) {
    if (response.status !== 'fail') {
      // FIXME: getContestsInterestedIn API inconsistently
      // returns a {} and an []. Below is a workaround.
      response.contestsInterestedIn = Object.keys(response.contestsInterestedIn).map(function (key) {
        return response.contestsInterestedIn[key];
      });

      return response;
    }
  });
}

var commentTemplate = "<li class=\"commentBoard-comment\" data-selector=\"comment-main\" data-message-id=\"<%-  msg_id  %>\">\n    <img src=\"<%-  profile_logo_url  %>\" class=\"commentBoard-avatar\" alt=\"<%-  publicUserName  %>\" />\n    <header class=\"commentBoard-headerItems\">\n        <%  if (!is_holder_message) {  %>\n            <h6 class=\"commentBoard-commentHeader\">\n                <a href=\"<%-  user_url  %>\" class=\"username\"><%-  publicUserName  %></a>\n            </h6>\n        <%  } else {  %>\n            <span class=\"commentBoard-userType\"><%= T_('콘테스트 주최자') %></span>\n        <%  }  %>\n        <ul class=\"commentBoard-commentDetails\" data-selector=\"comment-details\"></ul>\n    </header>\n    <p><%=  formattedComment  %></p>\n    <ul class=\"commentBoard-commentDetails commentBoard-mobile\" data-selector=\"comment-details\"></ul>\n    <%  if(!parentId) {  %>\n        <%  if (totalHiddenMessages > 0) {  %>\n            <div class=\"commentBoard-viewReplies view-more-comment\" data-parent-id=\"<%-  msg_id  %>\">\n                <a href=\"javascript:void(0);\" class=\"small\" data-selector=\"view-more-comment-link\">\n                    <%  if (totalHiddenMessages == 1) {  %>\n                        <%= T_(\"메시지 한 건 더 확인\") %>\n                    <%  } else {  %>\n                        <%= T_(\"메시지 <[- totalHiddenMessages]>건 더 확인\", { totalHiddenMessages: totalHiddenMessages }) %>\n                    <%  }  %>\n                </a>\n                <img src=\"<%=  cdn_url('/img/ajax-loader.gif')  %>\" class=\"view-more-comment-loader hide\"\n                  data-selector=\"view-more-comment-loader\" alt=\"<%= T_('처리중...') %>\"/>\n            </div>\n        <%  }  %>\n        <ol class=\"commentBoard-subList contest-replies\" data-selector=\"comment-reply-list\"></ol>\n    <%  }  %>\n</li>\n";

var entryItemTemplate = "<li class=\"TopContest-item\">\n    <div class=\"ShowcaseCard\">\n        <div class=\"ShowcaseCard-cover\">\n            <a class=\"ShowcaseCard-cover-link\" href=\"<%-  logo_large_url  %>\">\n                <figure class=\"ShowcaseCard-figure ShowcaseCard-figure--fixed\">\n                    <img class=\"ShowcaseCard-figure-image\" alt=\"<%-  altText  %>\" src=\"<%-  thumbCard  %>\">\n                </figure>\n                <div class=\"ShowcaseCard-overlay ShowcaseCard-overlay--zoom\">\n                    <div class=\"ShowcaseCard-overlay-inner\">\n                    </div>\n                </div>\n            </a>\n        </div>\n        <div class=\"ShowcaseCard-details\">\n            <a href=\"/u/<%-  userName  %>\" class=\"ShowcaseCard-details-primary\" data-lt-cta=\"GoToUserProfile\"><%-  userName  %></a>\n            <span class=\"ShowcaseCard-details-secondary\"><%-  userCountry  %></span>\n        </div>\n        <div class=\"ShowcaseCard-footer\">\n            <span class=\"ShowcaseCard-footer-primary Rating Rating--labeled\"\n                  data-star_rating=\"<%-  rating  %>\">\n                <span class=\"Rating-total\">\n                    <span class=\"Rating-progress\"></span>\n                </span>\n            </span>\n            <div class=\"ShowcaseCard-footer-secondary\">\n                <div class=\"showcasecard-likeContainer\">\n                    <div class=\"LikeCounter\n                    <%  if (num_likes > 0) {  %>\n                        is-LikeCounter-filled\n                    <%  }  %>\"><%=  uiIcon('flicon-heart')  %> <%-  num_likes  %></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</li>\n";

var pageNum = 1;

// Tracking for all CTA's in the page
jq('[data-lt-cta]').click(function () {
  var cta = jq(this);
  var tracking = cta.closest('[data-lt-cta]').data('lt-cta');
  if (tracking) {
    _lt.push(['user_action', {
      section: 'ContestLoggedOutCVP',
      subsection: tracking,
      label: jq.trim(cta.text())
    }]);
  }
});

Array.from(document.querySelectorAll('[data-lt-cta="PostContest"]')).forEach(function (element) {
  return element.addEventListener('click', function (event) {
    _lt.push(['user_action', {
      name: 'GoToPostContest',
      section: 'CVPLoggedOut',
      subsection: event.currentTarget.getAttribute('data-location'),
      value: 'Post',
      reference: 'contest_id',
      reference_id: contestId
    }]);

    _ttref.push(['_clearEntrypoint', 'PostContest']);
    _ttref.push(['_setCookie', 'PostContest_CVPLoggedOut']);
    _ttref.push(['_trackEvent', 'PostContest', 'PCPRedirect']);
  });
});

Array.from(document.querySelectorAll('[data-lt-cta="EnterThisContest"]')).forEach(function (element) {
  return element.addEventListener('click', function (event) {
    _lt.push(['user_action', {
      name: 'GoToEnterThisContest',
      section: 'CVPLoggedOut',
      subsection: event.currentTarget.getAttribute('data-location'),
      value: 'Post',
      reference: 'contest_id',
      reference_id: contestId
    }]);

    _ttref.push(['_clearEntrypoint', 'EnterThisContest']);
    _ttref.push(['_setCookie', 'EnterThisContest_CVPLoggedOut']);
    _ttref.push(['_trackEvent', 'EnterThisContest', 'LoginRedirect']);
  });
});

if (showMessageBoard) {
  new MessageBoard({
    contest: {
      id: contestId
    },
    preload: {
      enabled: true,
      messagesData: messagesData,
      prerendered: true
    },
    messageTemplate: commentTemplate,
    controls: {
      delete: false,
      reply: false,
      report: false
    }
  });

  init();
}

// Logic for Viewing More Entries
if (allowViewMoreEntries) {
  jq('.view-more-btn').on('click', function () {
    var ENTRIES_PER_PAGE = 16;
    var data = {
      project_id: contestId,
      offset: pageNum * ENTRIES_PER_PAGE
    };

    jq.ajax({
      url: '/ajax/contest/getTopEntriesPerPage.php',
      type: 'GET',
      data: data,
      dataType: 'json',
      success: function success(data) {
        pageNum++;
        jq.each(data.output.entries, function (i, val) {
          var templateData = {
            logo_large_url: val.logo_large_url,
            altText: val.altText,
            thumb900: val.thumb900,
            thumbCard: val.thumbCard,
            userName: val.userName,
            userCountry: val.userCountry,
            rating: val.rating,
            num_likes: val.num_likes,
            T_: translate,
            uiIcon: uiIcon
          };
          var temp = _.template(entryItemTemplate)(templateData);
          jq('.TopContest-cards').append(temp);
        });
        if (pageNum * ENTRIES_PER_PAGE > topEntriesCount) {
          jq('.view-more-btn').off('click');
          jq('.view-more-btn').hide();
        }
      }
    });
  });
}
